/* ============================================================
   BLUE SALON — Shopify theme JS
   Ported from the static storefront app.js. Content now comes
   from Liquid; this file only wires up behavior.
   ============================================================ */
(function () {
  "use strict";

  /* ── Reading direction ──────────────────────────────────────
     A horizontal scroll container reports scrollLeft relative to its START
     edge: 0..max going right in LTR, but 0..-max going LEFT in RTL. So every
     raw `scrollLeft` comparison in a slider inverts the moment the page is
     Arabic — "previous" reads as permanently disabled, "next" never disables,
     and a modulo marquee stops wrapping.

     These wrap it in a position that always counts UP from the start edge,
     whichever way the page reads, so the arithmetic at the call sites stays
     the same in both directions.

     Exposed on window.BS because listing.js, product.js, offers-page.js and
     cart.js need the same thing; every one of them is loaded with `defer`
     after this file, so the object exists by the time they run.

     Note: this assumes the modern (negative-in-RTL) scrollLeft model, which
     is what every current browser implements. */
  var BS = (window.BS = window.BS || {});
  BS.storefrontUrl = function (path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || "/") + String(path || "").replace(/^\//, "");
  };
  BS.rtl = {
    /* is this element (or the document) laid out right-to-left? */
    is: function (el) {
      var node = el && el.nodeType === 1 ? el : document.documentElement;
      return window.getComputedStyle(node).direction === "rtl";
    },
    /* how far the container has travelled from its start edge — always >= 0 */
    pos: function (el) {
      return Math.abs(el.scrollLeft);
    },
    /* jump to a distance from the start edge */
    setPos: function (el, value) {
      el.scrollLeft = BS.rtl.is(el) ? -value : value;
    },
    /* nudge along the reading order: positive = onward/next */
    by: function (el, distance, smooth) {
      el.scrollBy({
        left: BS.rtl.is(el) ? -distance : distance,
        behavior: smooth ? "smooth" : "auto"
      });
    },
    /* the furthest this container can travel */
    max: function (el) {
      return el.scrollWidth - el.clientWidth;
    }
  };
  /* There is deliberately no helper for "which physical edge is the start".
     Anything positioned along the inline axis carries its offset in a custom
     property and is placed with inset-inline-start in CSS (--truck-pos,
     --puck-pos, --mz-progress), so neither Liquid nor JS has to know the
     direction to put it in the right place. */

  /* ── Announcement bar: auto-rotating messages ───────────── */
  function initAnnouncements() {
    var announceMsg = document.getElementById("announceMsg");
    if (!announceMsg || announceMsg.dataset.initialized) return;
    announceMsg.dataset.initialized = "true";

    function parse(json) {
      try {
        return JSON.parse(json || "[]");
      } catch (e) {
        return [];
      }
    }
    var desktopMessages = parse(announceMsg.dataset.announcements);
    var mobileMessages = parse(announceMsg.dataset.announcementsMobile);
    if (!mobileMessages.length) mobileMessages = desktopMessages;
    // Mobile (≤768, same breakpoint the services strip hides its delivery
    // card at) rotates an extra free-delivery message ahead of the rest.
    var mobileQuery = window.matchMedia("(max-width: 768px)");
    var messages = mobileQuery.matches ? mobileMessages : desktopMessages;
    var idx = 0;
    if (messages.length) announceMsg.textContent = messages[0];

    mobileQuery.addEventListener("change", function (e) {
      messages = e.matches ? mobileMessages : desktopMessages;
      idx = 0;
      if (messages.length) announceMsg.textContent = messages[0];
    });

    if (desktopMessages.length < 2 && mobileMessages.length < 2) return;

    setInterval(function () {
      if (messages.length < 2) return;
      announceMsg.classList.add("is-leaving");
      setTimeout(function () {
        idx = (idx + 1) % messages.length;
        announceMsg.textContent = messages[idx];
        announceMsg.classList.remove("is-leaving");
        announceMsg.classList.add("is-entering");
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            announceMsg.classList.remove("is-entering");
          });
        });
      }, 300);
    }, 4000);
  }

  /* ── Sticky nav: reappears at the viewport top on scroll-up ── */
  function initStickyNav() {
    var navZone = document.getElementById("navZone");
    var headerEl = document.querySelector(".bs-header");
    if (!navZone || !headerEl || navZone.dataset.stickyInit) return;
    navZone.dataset.stickyInit = "true";

    var navSearchBtn = document.getElementById("navSearchBtn");
    var searchForm = document.querySelector(".bs-search");
    var searchInput = searchForm ? searchForm.querySelector("input") : null;
    var searchCloseBtn = searchForm ? searchForm.querySelector(".bs-search-close") : null;

    // Clicking the sticky nav's search icon used to scroll the whole page
    // back to the top just to reach the topbar's search bar — a jarring,
    // disorienting jump for what should be a lightweight action. Reveal the
    // SAME .bs-search form (not a duplicate, so its clear button/
    // autocomplete wiring keeps working) as a floating card right under the
    // sticky bar instead — same technique initMobileSearchTrigger already
    // uses to reposition this form over the topbar on mobile.
    function openNavSearch() {
      if (!searchForm || !navSearchBtn) return;
      var btnRect = navSearchBtn.getBoundingClientRect();
      var zoneRect = navZone.getBoundingClientRect();
      // Floating card right under the icon that opened it.
      searchForm.style.top = zoneRect.bottom + "px";
      searchForm.style.left = "";
      searchForm.style.right = "";
      /* align the panel's edge with the button's, measured from whichever
         side the page reads from */
      if (BS.rtl.is(searchForm)) {
        searchForm.style.left = btnRect.left + "px";
      } else {
        searchForm.style.right = (window.innerWidth - btnRect.right) + "px";
      }
      searchForm.classList.add("is-nav-search-open");
      navSearchBtn.setAttribute("aria-expanded", "true");
      // The button itself grabs focus as the default action of the click
      // that's opening the panel — a rAF-scheduled focus() lost that race
      // in testing, so give it a beat longer instead. preventScroll matters
      // here: the browser's default focus() scrolls the target into view,
      // and since the input's pre-fixed layout position is still way down
      // the page at this instant, that scroll-into-view yanked the whole
      // page back to wherever the input "normally" sits — which also
      // crossed back below the sticky threshold and dropped #navZone out
      // of .is-sticky, undoing the very thing this panel was opened for.
      if (searchInput) {
        setTimeout(function () { searchInput.focus({ preventScroll: true }); }, 100);
      }
    }

    function closeNavSearch() {
      if (!searchForm) return;
      searchForm.classList.remove("is-nav-search-open");
      if (navSearchBtn) navSearchBtn.setAttribute("aria-expanded", "false");
      // Without this, the inline top/left openNavSearch() sets for the
      // fixed-positioned sticky-bar placement stayed on the element after
      // closing — harmless while .is-nav-search-open (position:fixed) was
      // still applied, but once that class comes off, .bs-search reverts
      // to its default position:relative, where leftover top/left act as
      // an offset instead of a no-op, and shifted the topbar's own copy of
      // this same form down and sideways from its normal spot.
      searchForm.style.top = "";
      searchForm.style.left = "";
      searchForm.style.right = "";
    }

    var lastScrollY = window.scrollY;
    var scrollDirection = "down";
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      // Momentum/trackpad scrolling constantly produces 1px reversals mid-gesture;
      // comparing every tick to the previous one flips direction dozens of times a
      // second, toggling .is-sticky (and the fixed/static position it applies)
      // rapidly enough to look like the header jittering sideways. Only trust a
      // direction once it's moved a few px, so a single continuous scroll reads
      // as one direction instead of flickering.
      if (Math.abs(y - lastScrollY) > 5) {
        scrollDirection = y < lastScrollY ? "up" : "down";
        lastScrollY = y;
      }
      var pastHeader = y > headerEl.offsetHeight;
      var scrollingUp = scrollDirection === "up";
      if (pastHeader && scrollingUp) {
        if (!navZone.classList.contains("is-sticky")) {
          headerEl.style.paddingBottom = navZone.offsetHeight + "px";
          navZone.classList.add("is-sticky");
        }
      } else if (navZone.classList.contains("is-sticky")) {
        navZone.classList.remove("is-sticky");
        headerEl.style.paddingBottom = "";
        closeNavSearch();
      }
    }, { passive: true });

    if (navSearchBtn && searchForm) {
      navSearchBtn.addEventListener("click", function () {
        if (searchForm.classList.contains("is-nav-search-open")) {
          closeNavSearch();
        } else {
          openNavSearch();
        }
      });
      if (searchCloseBtn) {
        searchCloseBtn.addEventListener("click", function (e) {
          e.preventDefault();
          closeNavSearch();
        });
      }
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && searchForm.classList.contains("is-nav-search-open")) closeNavSearch();
      });
      document.addEventListener("click", function (e) {
        if (
          searchForm.classList.contains("is-nav-search-open") &&
          !searchForm.contains(e.target) &&
          e.target !== navSearchBtn &&
          !navSearchBtn.contains(e.target)
        ) {
          closeNavSearch();
        }
      });
      window.addEventListener("resize", function () {
        if (searchForm.classList.contains("is-nav-search-open")) closeNavSearch();
      });
    }
  }

  /* ── Mobile topbar: #navZone is display:none below 900px, so the
     desktop sticky nav above never fires there. Give mobile the same
     affordance on the topbar itself — it returns to the top of the
     viewport on scroll-up, and whenever something lands in the bag so
     the shopper sees the count tick up. ── */
  function initMobileStickyBar() {
    var topbar = document.querySelector(".bs-topbar");
    var headerEl = document.querySelector(".bs-header");
    if (!topbar || !headerEl || topbar.dataset.mobileStickyInit) return;
    topbar.dataset.mobileStickyInit = "true";

    var mobileMQ = window.matchMedia("(max-width: 900px)");
    var lastScrollY = window.scrollY;
    var scrollDirection = "down";

    function stick() {
      if (topbar.classList.contains("is-mobile-stuck")) return;
      // Going fixed pulls the bar out of flow and would collapse the header
      // by its height — pad the header by the same amount so the page
      // underneath doesn't jump. Mirrors the desktop navZone trick above.
      headerEl.style.paddingBottom = topbar.offsetHeight + "px";
      topbar.classList.add("is-mobile-stuck");
    }

    function unstick() {
      if (!topbar.classList.contains("is-mobile-stuck")) return;
      topbar.classList.remove("is-mobile-stuck");
      headerEl.style.paddingBottom = "";
    }

    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      if (!mobileMQ.matches) {
        lastScrollY = y;
        return;
      }
      // Same de-jitter guard as initStickyNav above — filters out the 1px
      // reversals momentum scrolling produces mid-gesture so the bar doesn't
      // flicker between fixed/static repeatedly during one continuous scroll.
      if (Math.abs(y - lastScrollY) > 5) {
        scrollDirection = y < lastScrollY ? "up" : "down";
        lastScrollY = y;
      }
      // Only once the real header has scrolled away — before that the bar
      // is still in view on its own and pinning it would just double up.
      if (y > headerEl.offsetHeight && scrollDirection === "up") stick();
      else unstick();
    }, { passive: true });

    document.addEventListener("bs:cart:added", function () {
      if (!mobileMQ.matches) return;
      if (window.scrollY > headerEl.offsetHeight) stick();
    });

    // Crossing back to desktop leaves a fixed bar stranded over the layout.
    // Guarded because pre-14 Safari has no addEventListener on a media query
    // list, and throwing here would take the listeners above down with it.
    if (mobileMQ.addEventListener) {
      mobileMQ.addEventListener("change", function (event) {
        if (!event.matches) unstick();
      });
    }
  }

  /* ── Search field clear button ─────────────────────────────────────
     Replaces the control browsers add to <input type="search"> (hidden in
     blue-salon.css). Two reasons it can't just be left to the browser:
     it's drawn to the browser's own taste rather than the theme's, and it
     only empties the field — the search app listens for `input` events to
     drive its dropdown, so clearing natively left the previous results and
     the panel sitting open, which reads as the button doing nothing.
     Dispatching the event ourselves is what actually resets the dropdown. */
  function initSearchClear() {
    var btn = document.getElementById("searchClear");
    var form = document.querySelector(".bs-search");
    var input = form ? form.querySelector('input[name="q"]') : null;
    if (!btn || !input || btn.dataset.clearInit) return;
    btn.dataset.clearInit = "true";

    function sync() {
      btn.hidden = input.value.length === 0;
    }

    input.addEventListener("input", sync);
    input.addEventListener("change", sync);

    btn.addEventListener("click", function () {
      input.value = "";
      // A real InputEvent, not a bare Event: the search app ignores the
      // latter (established while wiring the gender tabs — see
      // assets/search-gender-scope.js), so the dropdown would keep its
      // stale results and the field would look cleared but still "searched".
      input.dispatchEvent(
        new InputEvent("input", { bubbles: true, cancelable: true, data: null, inputType: "deleteContentBackward" })
      );
      sync();
      input.focus();
    });

    sync();
  }

  /* ── Mobile search icon: reveals the same .bs-search bar used on
     desktop (normally display:none below 900px) inline over the
     topbar, since there's no room for it alongside the other icons.
     The icon itself doubles as the toggle — tap again to close. ── */
  function initMobileSearchTrigger() {
    var btn = document.getElementById("mobileSearchBtn");
    var topbar = document.querySelector(".bs-topbar");
    var searchForm = document.querySelector(".bs-search");
    var searchInput = searchForm ? searchForm.querySelector("input") : null;
    var closeBtn = document.getElementById("mobileSearchClose");
    if (!btn || !topbar || !searchForm || !searchInput || btn.dataset.searchInit) return;
    btn.dataset.searchInit = "true";

    function openSearch() {
      topbar.classList.add("is-search-open");
      searchForm.classList.add("is-mobile-active");
      btn.setAttribute("aria-expanded", "true");
      searchInput.focus();
    }

    function closeSearch() {
      topbar.classList.remove("is-search-open");
      searchForm.classList.remove("is-mobile-active");
      btn.setAttribute("aria-expanded", "false");
    }

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (searchForm.classList.contains("is-mobile-active")) {
        closeSearch();
      } else {
        openSearch();
      }
    });
    if (closeBtn) {
      closeBtn.addEventListener("click", function (e) {
        e.preventDefault();
        closeSearch();
      });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && searchForm.classList.contains("is-mobile-active")) closeSearch();
    });
    window.addEventListener("resize", function () {
      if (window.innerWidth > 900 && searchForm.classList.contains("is-mobile-active")) closeSearch();
    });
  }

  /* Shared by alignMegaGroups/alignMegaHeadings below: given elements
     bucketed by their position-within-parent, pads every element in each
     bucket down (margin-top) to match whichever sibling in that bucket
     rendered tallest, so same-position items across columns land on the
     same line. There's no CSS-only fix — it needs each column's own
     rendered height, which only exists after layout. */
  function equalizeBucketedTops(buckets) {
    Object.keys(buckets).forEach(function (i) {
      var group = buckets[i];
      if (group.length < 2) return;
      var tops = group.map(function (el) { return el.getBoundingClientRect().top; });
      var maxTop = Math.max.apply(null, tops);
      group.forEach(function (el, idx) {
        var diff = maxTop - tops[idx];
        if (diff > 0.5) {
          var current = parseFloat(getComputedStyle(el).marginTop) || 0;
          el.style.marginTop = (current + diff) + "px";
        }
      });
    });
  }

  /* A column's 2nd+ *group* (e.g. "Niche Fragrance" stacked under
     "Fragrances") starts wherever the 1st group's own item count happens
     to end — which varies column to column, so 2nd+ groups drift out of
     alignment with their counterparts in neighbouring columns. Must run
     before alignMegaHeadings so that function's measurements reflect
     these repositioned groups, not the pre-adjustment layout. */
  /* Women-specific path: keep the primary row anchored, then place only
     secondary categories into the shortest available column. */
  function balanceMegaGroups(panel) {
    var links = panel.querySelector(".bs-mega-links");
    if (!links) return;

    var columns = Array.prototype.filter.call(links.children, function (el) {
      return el.classList.contains("bs-mega-col");
    });
    if (columns.length < 2) return;

    /* Menu-editor [Heading] entries create subsections inside one category
       list. Keep the first subsection attached to its primary category, but
       promote every later subsection (heading + following links) to a direct
       column group so it can fill a shorter neighbouring column as a unit. */
    columns.forEach(function (column) {
      var sourceGroups = Array.prototype.filter.call(column.children, function (el) {
        return el.classList.contains("bs-col") && !el.classList.contains("bs-col--subgroup");
      });

      sourceGroups.forEach(function (sourceGroup) {
        if (sourceGroup.dataset.subgroupsSplit) return;
        sourceGroup.dataset.subgroupsSplit = "true";

        var list = Array.prototype.find.call(sourceGroup.children, function (el) {
          return el.tagName === "UL";
        });
        if (!list) return;

        var headings = Array.prototype.filter.call(list.children, function (el) {
          return el.classList.contains("bs-mm-heading-row");
        });
        var movableHeadings = headings;
        if (headings[0] === list.firstElementChild) movableHeadings = headings.slice(1);
        if (!movableHeadings.length) return;

        var insertionPoint = sourceGroup;
        movableHeadings.forEach(function (heading) {
          var subgroup = document.createElement("div");
          subgroup.className = "bs-col bs-col--subgroup";
          var seq = Number(links.dataset.subgroupSeq || 0);
          subgroup.dataset.megaSubgroupOrder = String(seq);
          links.dataset.subgroupSeq = String(seq + 1);
          var subgroupList = document.createElement("ul");
          var item = heading;

          while (item) {
            var nextItem = item.nextElementSibling;
            subgroupList.appendChild(item);
            if (!nextItem || nextItem.classList.contains("bs-mm-heading-row")) break;
            item = nextItem;
          }

          subgroup.appendChild(subgroupList);
          insertionPoint.parentNode.insertBefore(subgroup, insertionPoint.nextSibling);
          insertionPoint = subgroup;
        });
      });
    });

    /* ONLY the subgroups promoted above are free to move. They were carved
       out of a single category list, so relocating one changes nothing a
       shopper reads as an ordering. Every group that 'mega-menu-plan' placed
       stays exactly where Liquid put it — the plan already decides the row
       order and which category sits under which, and a second, pixel-based
       pass here would silently override it (it used to, which is why Watches
       would not stay under Bags). Sorting by the creation-time index keeps
       placement identical across re-opens and resizes. */
    var movableGroups = Array.prototype.slice.call(
      links.querySelectorAll("[data-mega-subgroup-order]")
    ).sort(function (a, b) {
      return Number(a.dataset.megaSubgroupOrder) - Number(b.dataset.megaSubgroupOrder);
    });
    if (!movableGroups.length) return;

    /* An authored column plan (the "Start a new column at group" setting)
       decides the arrangement deliberately, so the height-balancing below
       must not run: it moves a subsection into whichever column is shortest,
       which is how Kids' "Baby boys" ended up beneath "Top brands". Leaving
       them where the split put them keeps every subsection under the category
       it belongs to. */
    if (panel.hasAttribute("data-mega-authored")) return;

    /* A CSS-grid item stretches to the tallest sibling, so offsetHeight is
       not a useful measure here. Sum each column's actual groups and its
       flex gap instead; this reflects the visual content height precisely. */
    function contentHeight(col) {
      var groups = Array.prototype.filter.call(col.children, function (el) {
        return el.classList.contains("bs-col");
      });
      var styles = getComputedStyle(col);
      var gap = parseFloat(styles.rowGap || styles.gap) || 0;
      return groups.reduce(function (height, group) {
        return height + group.getBoundingClientRect().height;
      }, 0) + Math.max(0, groups.length - 1) * gap;
    }

    movableGroups.forEach(function (group) {
      group.style.marginTop = "";
      group.remove();
    });

    movableGroups.forEach(function (group) {
      var shortest = columns[0];
      var shortestHeight = contentHeight(shortest);
      columns.slice(1).forEach(function (col) {
        var height = contentHeight(col);
        if (height < shortestHeight) {
          shortest = col;
          shortestHeight = height;
        }
      });
      shortest.appendChild(group);
    });
  }

  /* Choose the compact Women layout or retain the shared aligned-row layout
     used by the other department menus. */
  function alignMegaGroups(panel) {
    if (panel.classList.contains("bs-mega-panel--balanced-flow")) {
      balanceMegaGroups(panel);
      return;
    }

    var buckets = {};
    panel.querySelectorAll(".bs-mega-col").forEach(function (col) {
      var groups = col.querySelectorAll(".bs-col");
      groups.forEach(function (g, i) {
        if (i === 0) return;
        g.style.marginTop = ""; // clear a stale adjustment from a previous open at a different width
        (buckets[i] = buckets[i] || []).push(g);
      });
    });
    equalizeBucketedTops(buckets);
  }

  /* Within one group, a 2nd+ [Heading] sub-section (e.g. "Baby Boys ·
     9–36m") starts wherever its own 1st sub-section's item count happens
     to end — which varies group to group ("Baby Girls" has 8 lines, the
     neighbouring "Girls" has 11), so sibling headings at the same
     position drift out of alignment. Position 1 of each list is
     skipped — it already lines up on its own, immediately under the h4
     rule (or, after alignMegaGroups above, wherever that group now
     starts). */
  function alignMegaHeadings(panel) {
    var allHeadings = panel.querySelectorAll("li.bs-mm-heading-row");
    allHeadings.forEach(function (heading) {
      heading.style.marginTop = "";
    });

    /* Balanced panels use compact, content-led flow. Do not push later
       subsections down merely to line them up with a neighbouring column. */
    if (panel.classList.contains("bs-mega-panel--balanced-flow")) return;

    var buckets = {};
    panel.querySelectorAll(".bs-col").forEach(function (col) {
      var headings = col.querySelectorAll("li.bs-mm-heading-row");
      headings.forEach(function (h, i) {
        if (i === 0) return;
        (buckets[i] = buckets[i] || []).push(h);
      });
    });
    equalizeBucketedTops(buckets);
  }

  /* ── Mega menu: open on hover intent, close on leaving the zone ──

     Two reported bugs shape this, and they pull in opposite directions:

     1. On a mouse, the panel used to open the instant the cursor touched a
        nav link — so a diagonal sweep from the logo toward the hero banner's
        SHOP NOW button dropped a full-width panel over the banner and the
        click landed on the menu instead. Fixed with hover intent: the
        pointer has to rest on a link for OPEN_DELAY before anything opens,
        which a passing sweep never does. Once a panel IS open, switching to
        a sibling link is instantaneous — at that point the shopper is
        demonstrably browsing the menu and a second delay just feels broken.

     2. On a touch screen (reported on iPad Pro) the first tap on WOMEN or
        LUGGAGE only fired the synthesised mouseenter, which opened the panel
        and swallowed the navigation; a second tap was needed to actually go
        to the page. Fixed by ignoring hover entirely for non-mouse pointers
        (pointerenter carries pointerType) — a tap is then just a link click
        and navigates on the first try, with the drawer/mega nav still
        reachable the way touch users already reach it.
     ── */
  function initMegaMenu() {
    var navZone = document.getElementById("navZone");
    var megaHolder = document.getElementById("megaHolder");
    if (!navZone || !megaHolder || navZone.dataset.megaInit) return;
    navZone.dataset.megaInit = "true";

    var navItems = navZone.querySelectorAll(".bs-nav-item");
    var panels = megaHolder.querySelectorAll("[data-mega-panel]");

    var OPEN_DELAY = 220;  // rest time before a first open
    var CLOSE_DELAY = 160; // grace period crossing the gap to the panel
    var openTimer = null;
    var closeTimer = null;

    function cancelTimers() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }

    function isOpen() {
      return megaHolder.classList.contains("is-open");
    }

    function closeMenu() {
      cancelTimers();
      megaHolder.classList.remove("is-open");
      panels.forEach(function (p) { p.hidden = true; });
      navItems.forEach(function (el) { el.classList.remove("active"); });
    }

    function openFor(el) {
      navItems.forEach(function (other) { other.classList.remove("active"); });
      panels.forEach(function (p) { p.hidden = true; });

      var key = el.dataset.menu;
      var panel = key && megaHolder.querySelector('[data-mega-panel="' + key + '"]');
      if (panel) {
        el.classList.add("active");
        panel.hidden = false;
        megaHolder.classList.add("is-open");
        alignMegaGroups(panel);
        alignMegaHeadings(panel);
      } else {
        megaHolder.classList.remove("is-open");
      }
    }

    // A tap, a stylus or an unknown pointer type must never open the panel;
    // only a real mouse hovers. Older browsers with no PointerEvent fall
    // back to mouseenter, where a coarse-pointer media query stands in.
    function hoverIsFromMouse(e) {
      if (e && e.pointerType) return e.pointerType === "mouse";
      return !(window.matchMedia && window.matchMedia("(hover: none)").matches);
    }

    navItems.forEach(function (el) {
      function onEnter(e) {
        if (!hoverIsFromMouse(e)) return;
        cancelTimers();
        // Already browsing the menu: swap panels with no wait.
        if (isOpen()) { openFor(el); return; }
        openTimer = setTimeout(function () {
          openTimer = null;
          openFor(el);
        }, OPEN_DELAY);
      }

      function onLeave() {
        if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      }

      if (window.PointerEvent) {
        el.addEventListener("pointerenter", onEnter);
        el.addEventListener("pointerleave", onLeave);
      } else {
        el.addEventListener("mouseenter", onEnter);
        el.addEventListener("mouseleave", onLeave);
      }

      // A deliberate click on a nav link is a request to go to that page,
      // not to look at the panel — drop any pending open so the panel does
      // not flash up over the page that is already loading.
      el.addEventListener("click", function () { closeMenu(); });
    });

    // Leaving the nav row toward the panel below it would otherwise close
    // the menu out from under the pointer, so the close waits out the gap
    // and is cancelled if the pointer arrives in the panel.
    navZone.addEventListener("mouseleave", function () {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMenu, CLOSE_DELAY);
    });
    navZone.addEventListener("mouseenter", function () {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    });
    megaHolder.addEventListener("mouseenter", function () {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    });
    megaHolder.addEventListener("mouseleave", function () {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMenu, CLOSE_DELAY);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen()) closeMenu();
    });
  }

  /* ── Account dropdown: click-to-open popover from the header
     account icon (desktop only — mobile uses the hamburger drawer's
     Sign In/Sign Up buttons instead). The icon keeps its real href
     to routes.account_url, so it still navigates there with JS off.
     Failed sign-in/recover submits redirect back here with #login
     or #recover appended (Shopify's customer_login/recover_customer_
     password form behavior), so this reopens the dropdown to reveal
     the error already rendered server-side via form.errors. ── */
  function initAccountDropdown() {
    var wrap = document.getElementById("accountWrap");
    var btn = document.getElementById("accountBtn");
    var dropdown = document.getElementById("accountDropdown");
    if (!wrap || !btn || !dropdown || dropdown.dataset.initialized) return;
    dropdown.dataset.initialized = "true";

    // Tracks the in-flight close's transitionend handler so a reopen can
    // cancel it. Without this, hovering back in right after hovering out
    // (exactly what the debounce below is meant to allow) could leave the
    // OLD close's transitionend listener attached; if it fired after the
    // reopen it would set hidden = true again and snap the dropdown shut
    // right after it visibly opened — read by a shopper as "sometimes it
    // just doesn't open".
    var pendingCloseHandler = null;

    // The popover is anchored to the account icon, which sits in the (non-
    // sticky) topbar — so it can only ever be opened while that icon is on
    // screen. Rather than close on scroll (see the click handler below), cap
    // the popover at the room actually left beneath the icon and let it
    // scroll internally. At 125-150% browser zoom the sign-in card plus an
    // expanded "Forgot your password?" is taller than the viewport, and
    // without this the SEND RESET LINK button sat below the fold with no way
    // to reach it.
    function sizeDropdown() {
      var rect = btn.getBoundingClientRect();
      // Room under the icon, less the popover's own 16px padding-top and a
      // 16px breathing gap at the window edge. Read by the card inside (the
      // custom property inherits) — see .bs-account-dropdown .bs-account-card.
      dropdown.style.setProperty(
        "--bs-account-dd-max",
        Math.max(200, window.innerHeight - rect.bottom - 32) + "px"
      );
    }

    function openDropdown() {
      if (pendingCloseHandler) {
        dropdown.removeEventListener("transitionend", pendingCloseHandler);
        pendingCloseHandler = null;
      }
      // Same rule the mobile nav drawer already follows (see openDrawer): the
      // cart drawer is the other overlay that can be up when a header control
      // is used, and it must not share the screen with this one. Without
      // this the popover opened at z-index 250 UNDER the drawer's 500 — on
      // screen, focusable, and invisible — and because the popover closes on
      // any outside click, dismissing the drawer dismissed the popover with
      // it. One panel at a time fixes both halves at once.
      if (typeof window.BS_closeCartDrawer === "function") window.BS_closeCartDrawer();
      dropdown.hidden = false;
      sizeDropdown();
      // Page scroll is locked behind the open popover instead of dismissing
      // it: a wheel/trackpad nudge while reaching for a field is not a
      // request to abandon the form. Scrolling happens inside the popover.
      document.body.style.overflow = "hidden";
      void dropdown.offsetWidth; // commit the closed state so the fade/slide animates
      dropdown.classList.add("is-open");
      dropdown.setAttribute("aria-hidden", "false");
      btn.setAttribute("aria-expanded", "true");
    }

    function closeDropdown() {
      dropdown.classList.remove("is-open");
      dropdown.setAttribute("aria-hidden", "true");
      btn.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
      pendingCloseHandler = function () {
        dropdown.hidden = true;
        dropdown.removeEventListener("transitionend", pendingCloseHandler);
        pendingCloseHandler = null;
      };
      dropdown.addEventListener("transitionend", pendingCloseHandler);
    }

    // The other half of the one-panel-at-a-time rule in openDropdown: the
    // cart drawer calls this before it reveals itself, so the pair closes
    // each other whichever one the shopper reaches for first. Mirrors
    // window.BS_closeCartDrawer, which exists for the same reason.
    window.BS_closeAccountDropdown = function () {
      if (dropdown.classList.contains("is-open")) closeDropdown();
    };

    // A failed sign-in redirects to the dedicated /account/login page, which
    // renders the very same form (errors and all) in the page body. Clicking
    // the account icon there used to stack an identical popover on top of it
    // — two "Sign in" forms showing two copies of the same error. On that
    // page the icon focuses the real form instead of opening anything.
    function onLoginPage() {
      var form = document.querySelector('.bs-account-narrow form[action*="/account/login"]');
      return !!form && /\/account\/login/.test(window.location.pathname);
    }

    function focusPageLoginForm() {
      var field = document.getElementById("CustomerEmail");
      if (!field) return false;
      try {
        field.scrollIntoView({ block: "center", behavior: "smooth" });
      } catch (e) {
        field.scrollIntoView();
      }
      field.focus();
      return true;
    }

    // Click-only to open: hovering used to pop the dropdown open just from
    // the pointer brushing past the icon. A click is a deliberate ask, so
    // it toggles — click again to close.
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (onLoginPage() && !dropdown.classList.contains("is-open")) {
        if (focusPageLoginForm()) return;
      }
      if (dropdown.classList.contains("is-open")) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    // Resizing (or zooming, which reports as a resize) changes how much room
    // is left under the icon, so re-measure rather than leave a stale cap.
    window.addEventListener("resize", function () {
      if (dropdown.classList.contains("is-open")) sizeDropdown();
    });

    document.addEventListener("click", function (e) {
      if (!dropdown.classList.contains("is-open")) return;
      // A target detached from the document during this same click cannot be
      // judged by contains() — it is inside nothing at all. Treat it as "not
      // an outside click": whatever removed it was our own UI reacting, and
      // closing on that is exactly the bug this guards against.
      if (!e.target.isConnected) return;
      if (!wrap.contains(e.target)) closeDropdown();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && dropdown.classList.contains("is-open")) closeDropdown();
    });

    if ((window.location.hash === "#login" || window.location.hash === "#recover") && !onLoginPage()) {
      openDropdown();
      if (window.location.hash === "#recover") {
        var details = dropdown.querySelector(".bs-account-recover");
        if (details) details.open = true;
      }
    }
  }

  /* ── Mobile drawer: hamburger-triggered drill-down nav ───── */
  function initMobileDrawer() {
    var btn = document.getElementById("hamburgerBtn");
    var drawer = document.getElementById("mobileDrawer");
    var scrim = document.getElementById("drawerScrim");
    var closeBtn = document.getElementById("drawerClose");
    var nav = document.getElementById("drawerNav");
    var rootPanel = nav && nav.querySelector(".bs-drawer-panel-root");
    if (!btn || !drawer || !scrim || !nav || drawer.dataset.initialized) return;
    drawer.dataset.initialized = "true";

 function resetPanels() {
  if (rootPanel) {
    rootPanel.classList.remove("is-pushed");
    rootPanel.classList.add("is-active");
  }
  nav.querySelectorAll(".bs-drawer-panel.is-active").forEach(function (p) {
    if (p !== rootPanel) p.classList.remove("is-active");
  });
}

    function openDrawer() {
      // The cart drawer is the one other full-screen overlay that can be up
      // when the hamburger is tapped. Opening on top of it left both on
      // screen at once (the nav visibly behind the cart, still clickable)
      // and both holding the body scroll lock. Close it first; the nav
      // still opens in the same gesture, it just doesn't share the screen.
      if (typeof window.BS_closeCartDrawer === "function") window.BS_closeCartDrawer();
      drawer.hidden = false;
      scrim.hidden = false;
      void drawer.offsetWidth; // commit the off-canvas state so the slide animates
      drawer.classList.add("is-open");
      scrim.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      btn.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    }

    function closeDrawer() {
      drawer.classList.remove("is-open");
      scrim.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      btn.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
      var onEnd = function () {
        drawer.hidden = true;
        scrim.hidden = true;
        resetPanels(); // next open should land back on the root list, not wherever we drilled to
        drawer.removeEventListener("transitionend", onEnd);
      };
      drawer.addEventListener("transitionend", onEnd);
    }

    btn.addEventListener("click", openDrawer);
    if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
    scrim.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer();
    });

    // Delegated on the whole drawer (not just the nav) so the pinned
    // footer bar's Store Locator trigger — a sibling of nav — is covered too.
    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-open-store-drawer]")) { closeDrawer(); return; }
      // A language switch stays open so its thumb can be seen sliding while
      // the other locale loads (see initLanguageSwitcher).
      if (e.target.closest(".bs-drawer-panel a") && !e.target.closest("[data-lang-option]")) { closeDrawer(); return; }

      // Nested group accordion within a drilled-into panel (one group open at a time).
      var groupBtn = e.target.closest(".bs-drawer-group-toggle");
      if (groupBtn) {
        var col = groupBtn.parentNode;
        var wasColOpen = col.classList.contains("is-open");
        var mega = col.closest(".bs-mega");
        if (mega) {
          mega.querySelectorAll(".bs-col.is-open").forEach(function (c) {
            c.classList.remove("is-open");
            var b = c.querySelector(".bs-drawer-group-toggle");
            if (b) b.setAttribute("aria-expanded", "false");
          });
        }
        if (!wasColOpen) {
          col.classList.add("is-open");
          groupBtn.setAttribute("aria-expanded", "true");
        }
        return;
      }

      // Drill forward: slide the target category's panel in over the root list.
      var openBtn = e.target.closest("[data-drawer-open]");
      if (openBtn) {
        var target = nav.querySelector('[data-drawer-panel="' + openBtn.getAttribute("data-drawer-open") + '"]');
        if (target) {
          if (rootPanel) rootPanel.classList.add("is-pushed");
          target.classList.add("is-active");
          nav.scrollTop = 0;
        }
        return;
      }

      // Back: slide the current sub-panel back out, revealing the root list.
      if (e.target.closest("[data-drawer-back]")) {
        var openPanel = e.target.closest(".bs-drawer-panel:not(.bs-drawer-panel-root)");
        if (openPanel) openPanel.classList.remove("is-active");
        if (rootPanel) rootPanel.classList.remove("is-pushed");
        return;
      }
    });

    // Reset if the viewport grows back to desktop.
    window.addEventListener("resize", function () {
      if (window.innerWidth > 900 && drawer.classList.contains("is-open")) closeDrawer();
    });
  }

  /* ── Store locator drawer: right-side panel with the map,
     address and phone numbers — static content, so no fetch. ── */
  /* Brand palette recolor for the Maps JavaScript API — the free iframe
     embed can't take a styles array (no JS API, no billing key), so this
     only applies to the opt-in google_maps_api_key path in initStoreMap. */
  var BS_MAP_STYLES = [
    { elementType: "geometry", stylers: [{ color: "#faf8f4" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#0e1722" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#faf8f4" }] },
    { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#c9d3da" }] },
    { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#f3efe6" }] },
    { featureType: "poi", stylers: [{ visibility: "off" }] },
    { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e3e6da" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
    { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#dfe3e8" }] },
    { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#f6f2e9" }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#002a57" }] },
    { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#002a57" }] },
    { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#faf8f4" }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#c3d3dc" }] },
    { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#7a97a8" }] }
  ];

  function loadGoogleMapsScript(apiKey, onReady) {
    if (window.google && window.google.maps) { onReady(); return; }
    var existing = document.querySelector("script[data-bs-maps-loader]");
    if (existing) { existing.addEventListener("load", onReady); return; }
    window.__bsGoogleMapsReady = onReady;
    var script = document.createElement("script");
    script.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(apiKey) + "&callback=__bsGoogleMapsReady";
    script.async = true;
    script.dataset.bsMapsLoader = "true";
    document.head.appendChild(script);
  }

  /* Only called once the drawer actually opens — the Maps JS API is a
     billed Google Cloud product, so it should never load on every page
     view just because the drawer exists in the DOM. */
  function initStoreMap(root) {
    if (!root || root.dataset.storeMapInited) return;
    var apiKey = root.getAttribute("data-api-key");
    var lat = parseFloat(root.getAttribute("data-lat"));
    var lng = parseFloat(root.getAttribute("data-lng"));
    var name = root.getAttribute("data-name") || "";
    if (!apiKey || isNaN(lat) || isNaN(lng)) return;
    root.dataset.storeMapInited = "true";

    loadGoogleMapsScript(apiKey, function () {
      var center = { lat: lat, lng: lng };
      var map = new google.maps.Map(root, {
        center: center,
        zoom: 15,
        styles: BS_MAP_STYLES,
        disableDefaultUI: true,
        zoomControl: true,
        fullscreenControl: true
      });
      new google.maps.Marker({
        position: center,
        map: map,
        title: name,
        icon: {
          path: "M12 2C7.6 2 4 5.6 4 10c0 6 8 12 8 12s8-6 8-12c0-4.4-3.6-8-8-8zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z",
          fillColor: "#003976",
          fillOpacity: 1,
          strokeColor: "#ffffff",
          strokeWeight: 1.5,
          scale: 1.6,
          anchor: new google.maps.Point(12, 22)
        }
      });
    });
  }

  function initStoreDrawer() {
    var triggers = document.querySelectorAll("#storeLocatorBtn, [data-open-store-drawer]");
    var drawer = document.getElementById("storeDrawer");
    var scrim = document.getElementById("storeDrawerScrim");
    var closeBtn = document.getElementById("storeDrawerClose");
    if (!triggers.length || !drawer || !scrim || drawer.dataset.initialized) return;
    drawer.dataset.initialized = "true";

    function openDrawer() {
      drawer.hidden = false;
      scrim.hidden = false;
      void drawer.offsetWidth; // commit the off-canvas state so the slide animates
      drawer.classList.add("is-open");
      scrim.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      initStoreMap(drawer.querySelector("[data-store-map]"));
    }

    function closeDrawer() {
      drawer.classList.remove("is-open");
      scrim.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      var onEnd = function () {
        drawer.hidden = true;
        scrim.hidden = true;
        drawer.removeEventListener("transitionend", onEnd);
      };
      drawer.addEventListener("transitionend", onEnd);
    }

    triggers.forEach(function (btn) {
      btn.addEventListener("click", openDrawer);
    });
    if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
    scrim.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer();
    });
  }

  /* ── Cart drawer: opens from the header bag icon, rendered
     live from /cart.js — quantity +/- and Remove call the real
     Ajax Cart API so the drawer always reflects the actual cart. ── */
  function escapeCartHtml(str) {
    return String(str == null ? "" : str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function formatCartMoney(cents) {
    var amount = (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "";
    return (currency ? currency + " " : "") + amount;
  }

  // Requests a Shopify CDN image URL at a given width
  // (e.g. ".../name.jpg?v=123" -> ".../name_200x.jpg?v=123").
  function cartImageUrl(src, width) {
    if (!src) return "";
    return src.replace(/(\.[a-z0-9]+)(\?|$)/i, "_" + width + "x$1$2");
  }
  function cartThumbUrl(src) {
    return cartImageUrl(src, 200);
  }
  function cartSwatchUrl(src) {
    return cartImageUrl(src, 60);
  }

  function initCartDrawer() {
    var openBtn = document.getElementById("cartOpenBtn");
    var scrim = document.getElementById("cartDrawerScrim");
    var drawer = document.getElementById("cartDrawer");
    var closeBtn = document.getElementById("cartDrawerClose");
    var body = document.getElementById("cartDrawerBody");
    var countEl = document.getElementById("cartDrawerCount");
    if (!openBtn || !scrim || !drawer || !body || drawer.dataset.initialized) return;
    drawer.dataset.initialized = "true";

    var busy = false;
    // Whether the drawer body has been rendered from /cart.js at least once
    // this page load — gates the first-open loading state (see openCartDrawer).
    var cartWarmed = false;

    function syncHeaderCount(count) {
      document.querySelectorAll("#cartCount").forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    // Refused qty change (out of stock) — a band over the line itself (see
    // .bs-cart-drawer-line-oos in cart-drawer.css) so the message names the
    // product it's about, matching the PLP's per-card .plp-card-oos rather
    // than a page-wide banner. Shown AFTER fetchAndRender's rebuild (it
    // replaces body.innerHTML wholesale, which would otherwise wipe an
    // overlay appended before it resolves) and re-located by line key since
    // the row itself is a brand new node post-rebuild. Auto-dismisses; the
    // node is removed after it fades so it never lingers in the markup.
    function showLineOos(key, message) {
      var line = body.querySelector('[data-line-key="' + key + '"]');
      if (!line) return;
      var el = line.querySelector(".bs-cart-drawer-line-oos");
      if (!el) {
        el = document.createElement("div");
        el.className = "bs-cart-drawer-line-oos";
        el.setAttribute("role", "alert");
        line.appendChild(el);
      }
      el.textContent = message;
      clearTimeout(el._oosTimer);
      void el.offsetWidth;
      el.classList.add("is-visible");
      el._oosTimer = setTimeout(function () {
        el.classList.remove("is-visible");
        setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 320);
      }, 4000);
    }

    // Drops a leading brand name — with or without a " - " separator — from
    // a product title, so it isn't duplicated with the brand line above it.
    // Same rule as stripBrandPrefixes in assets/listing.js for the PLP cards.
    function stripBrandPrefix(title, vendor) {
      if (!vendor || title.slice(0, vendor.length).toLowerCase() !== vendor.toLowerCase()) return title;
      return title.slice(vendor.length).replace(/^\s*-?\s*/, "");
    }

    var CART_TRASH_ICON =
      '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m2 0-.7 12a1 1 0 0 1-1 .9H7.7a1 1 0 0 1-1-.9L6 7"/>' +
      '<path d="M10 11v5M14 11v5"/></svg>';
    function findOption(item, matches) {
      var found = null;
      (item.options_with_values || []).forEach(function (opt) {
        if (!found && matches((opt.name || "").toLowerCase())) found = opt;
      });
      return found;
    }

    // was/now when the line is discounted in the cart (original_price >
    // final_price). Note: Shopify's /cart.js line items don't expose the
    // product's compare_at_price, so a compare-at-only "sale" price won't
    // show a strike here — only real cart/automatic discounts do.
    function priceHTML(item) {
      if (item.original_price > item.final_price) {
        return '<span class="was">' + formatCartMoney(item.original_price) + "</span>" +
          '<span class="now">' + formatCartMoney(item.final_price) + "</span>";
      }
      return formatCartMoney(item.final_price);
    }

    // Colour as a small swatch image (the line's own variant photo) — no
    // label, just the swatch — a colour name alone doesn't show what it
    // looks like anyway.
    function colourHTML(item, swatchImg) {
      var opt = findOption(item, function (n) { return n.indexOf("colour") !== -1 || n.indexOf("color") !== -1; });
      if (!opt) return "";
      var value = swatchImg
        ? '<img class="bs-cart-drawer-swatch" src="' + escapeCartHtml(swatchImg) + '" alt="' + escapeCartHtml(opt.value) + '">'
        : "<b>" + escapeCartHtml(opt.value) + "</b>";
      return '<div class="bs-cart-drawer-colour">' + value + "</div>";
    }

    // Size shown as plain text — display-only either way (changing size
    // still means removing and re-adding a different variant).
    function sizePillHTML(item) {
      var opt = findOption(item, function (n) { return n.indexOf("size") !== -1; });
      if (!opt) return "";
      return '<span class="bs-cart-drawer-size-pill">' + escapeCartHtml(opt.value) + "</span>";
    }

    function lineHTML(item) {
      var img = cartThumbUrl(item.image);
      var swatchImg = cartSwatchUrl(item.image);
      var sizePill = sizePillHTML(item);
      var title = stripBrandPrefix(item.product_title, item.vendor);
      return '<div class="bs-cart-drawer-line" data-cart-line data-line-key="' + escapeCartHtml(item.key) + '">' +
        '<div class="bs-cart-drawer-line-media">' +
          (img ? '<img src="' + escapeCartHtml(img) + '" alt="' + escapeCartHtml(item.product_title) + '">' : "") +
        "</div>" +
        '<div class="bs-cart-drawer-line-info">' +
          '<div class="bs-cart-drawer-line-head">' +
            "<div>" +
              '<div class="bs-cart-drawer-line-brand">' + escapeCartHtml(item.vendor) + "</div>" +
              '<a class="bs-cart-drawer-line-name" href="' + escapeCartHtml(item.url) + '">' +
                escapeCartHtml(title) + "</a>" +
            "</div>" +
            '<button type="button" class="bs-cart-drawer-remove" data-cart-remove aria-label="Remove">' +
              CART_TRASH_ICON + "</button>" +
          "</div>" +
          '<div class="bs-cart-drawer-line-price">' + priceHTML(item) + "</div>" +
          '<div class="bs-cart-drawer-line-foot">' +
            '<div class="bs-cart-drawer-foot-left">' +
              colourHTML(item, swatchImg) +
              sizePill +
            "</div>" +
            '<div class="bs-cart-drawer-qty-wrap">' +
              '<div class="bs-cart-drawer-qty">' +
                // At one unit the "−" becomes a bin that deletes the line
                // outright (matches the cart page). Both glyphs ship in the
                // button and .is-remove picks which shows.
                '<button type="button" data-cart-qty="-1" class="bs-cart-drawer-qty-dec' +
                  (item.quantity <= 1 ? " is-remove" : "") + '" aria-label="' +
                  (item.quantity <= 1
                    ? (CART_T.remove || "Remove")
                    : (CART_T.decrease_qty || "Decrease quantity")) + '">' +
                  '<span class="bs-cart-drawer-qty-minus" aria-hidden="true">−</span>' +
                  '<span class="bs-cart-drawer-qty-bin" aria-hidden="true">' + CART_TRASH_ICON + "</span>" +
                "</button>" +
                '<span class="bs-cart-drawer-qty-val">' + item.quantity + "</span>" +
                '<button type="button" data-cart-qty="1" aria-label="' +
                  (CART_T.increase_qty || "Increase quantity") +
                  '" aria-describedby="cartMaxTip-' +
                  escapeCartHtml(item.key) + '">+</button>' +
              "</div>" +
              '<div class="bs-cart-drawer-qty-tooltip" id="cartMaxTip-' + escapeCartHtml(item.key) + '" role="tooltip">' +
                "<b>" + (CART_T.no_more_stock || "No More Stock") + "</b>" +
                (CART_T.max_stock_note ||
                  "You&rsquo;ve already added everything we have to your bag.") +
              "</div>" +
            "</div>" +
          "</div>" +
        "</div>" +
      "</div>";
    }

    // Free-shipping progress bar — threshold is set in QAR (whole units)
    // via the header section's "Cart drawer" setting; cart totals from
    // /cart.js are in the smallest currency subunit, hence * 100.
    var CART_TRUCK_ICON =
      '<svg class="bs-icon-dir" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/>' +
      '<circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg>';
    var CART_CHECK_ICON =
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
      'stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

    function updateShippingProgress(cart) {
      var wrap = document.getElementById("cartShippingProgress");
      if (!wrap) return;
      var thresholdCents = (parseFloat(wrap.dataset.threshold) || 0) * 100;
      if (!thresholdCents) return;

      var subtotal = cart.items_subtotal_price;
      var complete = subtotal >= thresholdCents;
      var pct = Math.max(0, Math.min(100, Math.round((subtotal / thresholdCents) * 100)));
      var fill = document.getElementById("cartShippingFill");
      var truck = document.getElementById("cartShippingTruck");
      var msg = document.getElementById("cartShippingMsg");

      wrap.classList.toggle("is-complete", complete);
      if (fill) fill.style.width = pct + "%";
      if (truck) {
        /* --truck-pos feeds inset-inline-start in cart-drawer.css, so the
           truck travels from the reading start edge in either direction */
        truck.style.setProperty("--truck-pos", pct + "%");
        truck.innerHTML = complete ? CART_CHECK_ICON : CART_TRUCK_ICON;
      }
      if (msg) {
        msg.innerHTML = complete
          ? (CART_T.free_shipping_unlocked || "You've unlocked <b>Free Shipping</b>!")
          : (CART_T.free_shipping_add || "Add <b>__AMOUNT__</b> more for free shipping")
              .replace("__AMOUNT__", formatCartMoney(thresholdCents - subtotal));
      }
    }

    function subtotalLabel(count) {
      if (count === 1) return CART_T.subtotal_one || "Subtotal (1 item)";
      return (CART_T.subtotal_many || "Subtotal (__COUNT__ items)")
        .replace("__COUNT__", count);
    }

    function deliveryLabel(cart) {
      var wrap = document.getElementById("cartShippingProgress");
      var thresholdCents = wrap ? (parseFloat(wrap.dataset.threshold) || 0) * 100 : 0;
      return thresholdCents > 0 && cart.items_subtotal_price >= thresholdCents
        ? '<span class="bs-cart-delivery-free">' + (CART_T.delivery_free || "Free") + "</span>"
        : escapeCartHtml(CART_T.delivery_calculated_at_checkout || "Calculated at checkout");
    }

    // Max quantity per line key — /cart.js never exposes inventory data,
    // only Liquid does. sections/cart.liquid already renders each line's
    // real cap into its own data-max-qty attribute, so instead of guessing
    // at a second, separately-fetchable data source, the drawer just fetches
    // that same cart page (routes.cart_url) and reads it back out — the one
    // spot already confirmed to have the right number for every line.
    // Copy for everything this drawer builds at runtime, published by

    // snippets/storefront-i18n.liquid. English literals stay as fallbacks so

    // the drawer still reads correctly if the bridge has not loaded.

    var CART_T = (window.BS_I18N || {}).cart || {};



    var stockCaps = {};

    function refreshStockCaps() {
      var cartUrl = drawer.dataset.cartUrl || BS.storefrontUrl("cart");
      return fetch(cartUrl, { headers: { Accept: "text/html" } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          doc.querySelectorAll("[data-cart-line][data-line-key]").forEach(function (el) {
            var max = parseInt(el.dataset.maxQty, 10);
            if (!isNaN(max)) stockCaps[el.dataset.lineKey] = max;
          });
        })
        .catch(function () {});
    }

    // Marks a line's "+" button as maxed once its key is known (from
    // stockCaps) to already hold every available unit — a class rather than
    // the disabled attribute so its .bs-cart-drawer-qty-tooltip callout (see
    // cart-drawer.css) still shows on hover (disabled elements don't fire
    // hover in most browsers); the qty click handler below ignores clicks
    // on it instead.
    function applyStockCaps(cart) {
      cart.items.forEach(function (item) {
        var max = stockCaps[item.key];
        if (max == null) return;
        var line = body.querySelector('[data-line-key="' + item.key + '"]');
        var incBtn = line && line.querySelector('[data-cart-qty="1"]');
        if (incBtn) incBtn.classList.toggle("is-maxed", item.quantity >= max);
      });
    }

    function render(cart) {
      if (countEl) countEl.textContent = "(" + cart.item_count + ")";
      syncHeaderCount(cart.item_count);
      updateShippingProgress(cart);

      var existingSummary = drawer.querySelector(".bs-cart-drawer-summary");
      if (existingSummary) existingSummary.remove();

      var tabs = document.getElementById("cartDrawerTabs");
      if (tabs) tabs.hidden = !cart.items.length;

      if (!cart.items.length) {
        body.innerHTML =
          '<div class="bs-cart-drawer-empty">' +
            '<img class="bs-cart-drawer-empty-icon" src="https://cdn.shopify.com/s/files/1/0370/6444/1991/files/bluesalon-bag.png?v=1786009221" width="120" height="120" alt="" loading="lazy">' +
            '<p class="bs-cart-drawer-empty-title">' +
              (CART_T.empty_title || "Your bag is empty") + "</p>" +
            '<p class="bs-cart-drawer-empty-sub">' +
              (CART_T.empty_sub || "Looks like you haven’t added anything yet.") + "</p>" +
            '<a class="bs-cart-drawer-empty-cta" href="' + escapeCartHtml(drawer.dataset.shopUrl || "/") + '">' + (CART_T.continue_shopping || "Continue Shopping") + "</a>" +
          "</div>";
        return;
      }

      body.innerHTML = cart.items.map(lineHTML).join("");

      // Shipping is calculated at checkout; show Shopify's returned total.
      var itemTotal = cart.total_price;
      var summaryHTML =
        '<div class="bs-cart-drawer-summary">' +
          '<div class="bs-cart-drawer-row"><span>' + subtotalLabel(cart.item_count) +
            "</span><span>" +
            formatCartMoney(cart.items_subtotal_price) + "</span></div>" +
          '<div class="bs-cart-drawer-row"><span>' + (CART_T.delivery || "Delivery") +
            '</span><span>' + deliveryLabel(cart) + "</span></div>" +
          '<div class="bs-cart-drawer-row bs-cart-drawer-row--total"><span>' +
            (CART_T.item_total || "Item Total") + '</span><span>' +
            formatCartMoney(itemTotal) + "</span></div>" +
        "</div>";
      // Right after the item list, not the very end of the drawer — the
      // View Cart/Checkout tabs are a fixed footer that must stay last.
      body.insertAdjacentHTML("afterend", summaryHTML);

      applyStockCaps(cart);
      // The seed seen so far may predate a variant added to the bag this
      // session (see refreshStockCaps above) — correct once fresh data lands.
      refreshStockCaps().then(function () { applyStockCaps(cart); });
    }

    function fetchCart() {
      return fetch(BS.storefrontUrl("cart.js"), { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
    }

    function fetchAndRender() {
      return fetchCart()
        .then(function (cart) { render(cart); cartWarmed = true; return cart; })
        .catch(function () {});
    }

    // Neutral loading state for a first open that beats the /cart.js response
    // — a placeholder, never stale cart content, so nothing wrong ever flashes.
    function renderCartLoading() {
      if (body) {
        body.innerHTML =
          '<div class="bs-cart-drawer-loading" aria-hidden="true">' +
            '<span class="bs-cart-drawer-spinner"></span>' +
          "</div>";
      }
    }

    function changeLine(key, quantity) {
      if (busy) return;
      busy = true;
      body.classList.add("is-loading");
      fetch(BS.storefrontUrl("cart/change.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          // /cart/change.js refuses (422) instead of clamping when the
          // requested quantity exceeds stock — most often every unit of a
          // "only N left" variant is already in the bag. `data` is then an
          // error object (no items/item_count), so bail out here instead of
          // handing it to render() — that's what produced the "(undefined)"
          // count and "QAR NaN" free-shipping copy.
          if (data.status) {
            var message = data.status === 422
              ? (CART_T.out_of_stock || "It looks like this product is out of stock.")
              : (CART_T.update_failed ||
                 "Sorry, we couldn't update your bag. Please try again.");
            return fetchAndRender().then(function (freshCart) {
              // A 422 means `quantity` was refused — the line's own current
              // quantity is therefore the real ceiling for its variant, so
              // learn it now instead of waiting to be refused again next time.
              if (data.status === 422 && freshCart) {
                var item = freshCart.items.filter(function (i) { return i.key === key; })[0];
                if (item) {
                  stockCaps[key] = item.quantity;
                  applyStockCaps(freshCart);
                }
              }
              showLineOos(key, message);
            });
          }
          render(data);
        })
        .catch(function () {})
        .finally(function () {
          busy = false;
          body.classList.remove("is-loading");
        });
    }

    // Removing a line first collapses it out (slide + fade + height to 0),
    // then commits quantity:0 and re-renders — so the row animates away
    // instead of the whole list snapping to its new state. box-sizing is
    // forced to border-box for the collapse so the measured start height
    // matches regardless of the theme's default (the node is replaced on
    // render anyway). On a failed request we re-fetch to bring the row back.
    function removeLine(key, line) {
      if (busy) return;
      // Reduced-motion: skip the collapse and remove immediately.
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        changeLine(key, 0);
        return;
      }
      busy = true;
      var h = line.offsetHeight;
      line.style.boxSizing = "border-box";
      line.style.height = h + "px";
      line.style.overflow = "hidden";
      void line.offsetHeight; // commit the start height before collapsing
      line.classList.add("is-removing");
      line.style.height = "0px";
      line.style.paddingTop = "0px";
      line.style.paddingBottom = "0px";
      setTimeout(function () {
        fetch(BS.storefrontUrl("cart/change.js"), {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (r) { return r.json(); })
          .then(render)
          .catch(function () { fetchAndRender(); })
          .finally(function () { busy = false; });
      }, 260);
    }

    // Which bag icon the popover currently hangs off. Defaults to the
    // header's own, but any other bag icon on the page can claim it for
    // one open via BS_openCartDrawer(anchor) — see the PDP sticky top bar
    // in assets/product.js, which is the only bag icon still on screen
    // once that bar takes over on mobile.
    var anchorEl = openBtn;

    // Hang the popover just below the anchoring cart icon, off its live
    // position — the header isn't sticky and its height varies (optional
    // announcement bar, responsive breakpoints), so a static top would
    // drift. Also caps max-height so a long bag scrolls inside the popover
    // rather than running off-screen.
    function positionCartDrawer() {
      var viewportWidth = document.documentElement.clientWidth;
      var viewportHeight = document.documentElement.clientHeight;
      var r = (anchorEl || openBtn).getBoundingClientRect();

      // An anchor that's display:none (all-zero rect — e.g. the header
      // utils while the mobile search bar is open) or scrolled out of view
      // gives coordinates that would place the popover outside the
      // viewport entirely, which read as "the drawer didn't open at all".
      // Fall back to the viewport's own top-right in that case.
      var anchorUsable = (r.width > 0 || r.height > 0) &&
        r.bottom > 0 && r.top < viewportHeight &&
        r.right > 0 && r.left < viewportWidth;

      var top = anchorUsable ? Math.max(Math.round(r.bottom) + 10, 8) : 8;
      drawer.style.top = top + "px";
      // Size to the *dynamic* viewport, not 100vh: on mobile Safari 100vh is
      // the large viewport (as if the bottom toolbar were hidden), so the
      // drawer runs behind that toolbar and its pinned "View Cart" footer gets
      // tucked under it. dvh tracks the visible height and self-corrects as the
      // toolbar shows/hides; older browsers fall back to the visual viewport.
      var bottomGap = top + 20;
      if (window.CSS && CSS.supports && CSS.supports("height", "100dvh")) {
        drawer.style.maxHeight = "calc(100dvh - " + bottomGap + "px)";
      } else {
        var visibleH = (window.visualViewport && window.visualViewport.height) || viewportHeight;
        drawer.style.maxHeight = Math.max(visibleH - bottomGap, 160) + "px";
      }

      // On phones the icon-anchored popover is too narrow — it leaves a sliver
      // of page beside it and reads as cramped. Span the full width instead,
      // as a sheet dropping from below the header (the pointer + corner radius
      // are handled in cart-drawer.css's ≤600px block).
      if (window.matchMedia("(max-width: 600px)").matches) {
        drawer.style.left = "0px";
        drawer.style.right = "0px";
        drawer.style.width = "auto";
        drawer.style.removeProperty("--cart-pointer-right");
        return;
      }
      // Desktop/tablet: clear any full-width values a prior phone-width open
      // left behind, then anchor the popover off the cart icon.
      drawer.style.left = "";
      drawer.style.width = "";

      // Arabic (RTL): the bag icon sits at the left of the header, so the
      // popover hangs off the icon's left edge instead. Measuring from the
      // right as below gave a ~950px `right`, and in an RTL page the browser
      // honours `right` over rtl.css's `left: 16px`, so the drawer and its
      // close button ended up off-screen to the left. rtl.css reads
      // --cart-pointer-right as the pointer's distance from the left edge.
      if (getComputedStyle(drawer).direction === "rtl") {
        var startGap = anchorUsable ? Math.max(Math.round(r.left) - 6, 8) : 16;
        drawer.style.right = "auto";
        drawer.style.left = startGap + "px";
        var pointerLeft = anchorUsable
          ? Math.round(r.left + r.width / 2 - startGap)
          : 36;
        drawer.style.setProperty("--cart-pointer-right", Math.max(pointerLeft, 16) + "px");
        return;
      }

      // Align the popover's right edge just past the cart icon (which sits
      // at the right of the centred content container, not the far viewport
      // edge), and drop the pointer under the icon's centre. Uses
      // clientWidth, not window.innerWidth, since innerWidth includes the
      // scrollbar while getBoundingClientRect()/fixed positioning don't —
      // mixing the two shifted everything left by the scrollbar's width.
      var edgeGap = anchorUsable
        ? Math.max(Math.round(viewportWidth - r.right) - 6, 8)
        : 16;
      drawer.style.right = edgeGap + "px";
      var pointerRight = anchorUsable
        ? Math.round(viewportWidth - edgeGap - (r.left + r.width / 2))
        : 36;
      drawer.style.setProperty("--cart-pointer-right", Math.max(pointerRight, 16) + "px");
    }

    // Renders the fetched cart before the drawer ever becomes visible —
    // instead of revealing it first and re-rendering a beat later once
    // /cart.js resolves, which flashed whatever stale/empty content was
    // already in the DOM (or nothing, on the very first open) before the
    // real items popped in.
    // Tracks the in-flight close's transitionend handler so a reveal can
    // cancel it. Without this, a hover-out immediately followed by a
    // hover-back-in (exactly what the hover debounce further down is meant
    // to allow) could leave the OLD close's transitionend listener attached;
    // if it fired after the reveal it would set hidden = true again and
    // snap the drawer shut right after it visibly opened — read by a
    // shopper as "sometimes it just doesn't open".
    var pendingCloseHandler = null;

    function revealCartDrawer() {
      if (pendingCloseHandler) {
        drawer.removeEventListener("transitionend", pendingCloseHandler);
        pendingCloseHandler = null;
      }
      // One panel at a time — see openDropdown in initAccountDropdown. This
      // direction matters for the add-to-bag preview too: it reveals the
      // drawer without any click of its own, so an account popover left open
      // would otherwise end up buried under it.
      if (typeof window.BS_closeAccountDropdown === "function") window.BS_closeAccountDropdown();
      drawer.hidden = false;
      scrim.hidden = false;
      positionCartDrawer();
      void drawer.offsetWidth; // commit the closed state so the fade/slide animates
      drawer.classList.add("is-open");
      scrim.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      // Highlight the header cart icon (navy fill, white icon) while its
      // drawer is open — the active state removed again by closeCartDrawer.
      if (openBtn) openBtn.classList.add("is-active");
    }

    // Below this width the drawer is a full-width sheet rather than a popover
    // hanging off the bag icon, so it doesn't need to track the icon's
    // position — which is what the scroll-close further down exists for.
    function isCartSheet() {
      return window.innerWidth <= 900;
    }

    // Mobile: lock the background so the page behind the open drawer can't
    // move at all — the drawer's own body scrolls instead. html carries
    // `overflow-y: scroll` (see assets/blue-salon.css), which makes it the
    // scrolling element, so locking body alone left the page scrollable;
    // both have to be pinned. Released in closeCartDrawer.
    function lockBackgroundScroll() {
      if (!isCartSheet()) return;
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }

    function unlockBackgroundScroll() {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }

    function openCartDrawer() {
      clearPreviewTimer();
      // Open right away rather than blocking the reveal on the /cart.js
      // round-trip (the old fetch-then-reveal was the perceived lag). If the
      // body's never been rendered this page load, show a brief spinner so it
      // isn't blank; otherwise the last-rendered cart stays put. Either way,
      // refresh in the background and re-render when the request lands.
      // (openCartPreview stays fetch-then-reveal — it must show the just-added
      // item, not the pre-add cart.)
      if (!cartWarmed) renderCartLoading();
      revealCartDrawer();
      lockBackgroundScroll();
      fetchAndRender();
    }

    window.addEventListener("resize", function () {
      if (drawer.classList.contains("is-open")) positionCartDrawer();
    });

    function closeCartDrawer() {
      clearPreviewTimer();
      drawer.classList.remove("is-open");
      scrim.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      if (openBtn) openBtn.classList.remove("is-active");
      unlockBackgroundScroll();
      pendingCloseHandler = function () {
        drawer.hidden = true;
        scrim.hidden = true;
        drawer.removeEventListener("transitionend", pendingCloseHandler);
        pendingCloseHandler = null;
      };
      drawer.addEventListener("transitionend", pendingCloseHandler);
    }

    // Brief auto-dismissing preview — opened right after an Add to Cart on
    // the listing page, PDP or Quick View (see the CART_PREVIEW_EVENT
    // dispatch in those files) so the shopper sees confirmation without
    // having to close the drawer themselves. A genuine click on the header
    // bag icon (openBtn's own listener below) always stays open instead.
    var PREVIEW_MS = 3000;
    var previewTimer = null;
    function clearPreviewTimer() {
      if (previewTimer) { clearTimeout(previewTimer); previewTimer = null; }
    }
    function openCartPreview() {
      clearPreviewTimer();
      // Reveal immediately instead of waiting on the /cart.js round trip —
      // the same reveal-then-fetch pattern openCartDrawer already uses. The
      // add itself already succeeded by the time this runs, so there's
      // nothing wrong to flash: the drawer just slides in a beat before its
      // content (last-rendered cart, or a spinner on the very first add)
      // is patched to the just-added item. The auto-dismiss countdown still
      // waits for that patch, so the shopper gets a full PREVIEW_MS look at
      // the correct, final content either way.
      if (!cartWarmed) renderCartLoading();
      revealCartDrawer();
      fetchAndRender().then(function () {
        previewTimer = setTimeout(closeCartDrawer, PREVIEW_MS);
      });
    }
    // Hovering the open preview pauses the countdown so it doesn't vanish
    // while the shopper is actually looking at it; it resumes on mouseleave.
    drawer.addEventListener("mouseenter", function () {
      if (previewTimer) clearPreviewTimer();
    });
    drawer.addEventListener("mouseleave", function () {
      if (drawer.classList.contains("is-open") && drawer.dataset.previewing === "true") {
        previewTimer = setTimeout(closeCartDrawer, PREVIEW_MS);
      }
    });

    /* The hover pause above is mouse-only — mouseenter never fires on a
       touchscreen, so on a phone the preview closed after PREVIEW_MS no
       matter what the shopper was doing, mid-scroll through their bag
       included (bug #32). Any deliberate contact with the drawer — a tap,
       a scroll, a pen, or keyboard focus landing inside it — now ends the
       preview for good: the shopper has started using it, so it behaves
       like a drawer they opened themselves and stays until they close it.
       Converting rather than pausing is deliberate; resuming a countdown
       after a tap would close the drawer under a thumb that had just
       lifted. */
    function endPreview() {
      if (drawer.dataset.previewing !== "true") return;
      clearPreviewTimer();
      drawer.dataset.previewing = "false";
    }
    drawer.addEventListener("pointerdown", endPreview);
    drawer.addEventListener("touchstart", endPreview, { passive: true });
    drawer.addEventListener("wheel", endPreview, { passive: true });
    drawer.addEventListener("focusin", endPreview);
    window.BS_showCartPreview = function () {
      drawer.dataset.previewing = "true";
      anchorEl = openBtn;
      openCartPreview();
    };

    // Opens the drawer the same way a header-icon click does (stays open,
    // no auto-dismiss), optionally hanging it off a different bag icon.
    // Lets any other bag icon on the page — the PDP sticky top bar's, for
    // one — open the real drawer instead of simulating a click on the
    // header button, which is off-screen exactly when those other icons
    // are the ones being tapped.
    window.BS_openCartDrawer = function (anchor) {
      anchorEl = anchor || openBtn;
      delete drawer.dataset.previewing;
      openCartDrawer();
    };

    // Lets another overlay dismiss the cart before taking over the screen.
    // Reported bug: with the cart open, tapping the hamburger slid the nav
    // drawer in UNDERNEATH the cart — the menu was visible through/behind
    // it and still clickable, with two competing overlays and two scroll
    // locks fighting over the body. The hamburger now closes the cart
    // first (see initMobileDrawer). Returns whether anything was open, so
    // the caller can wait out the slide-away.
    window.BS_closeCartDrawer = function () {
      var wasOpen = drawer.classList.contains("is-open");
      if (wasOpen) closeCartDrawer();
      return wasOpen;
    };

    // Re-render the (hidden) drawer from /cart.js without opening it — used
    // after a mobile Add to Cart, which shows a toast instead of the drawer
    // (see showCartToast in assets/listing.js), so the bag is already fresh
    // and the just-added item is there the instant the shopper does open it.
    window.BS_refreshCart = fetchAndRender;

    // Warm /cart.js the moment the shopper shows intent to open (hover, focus,
    // or first touch) so the data is usually already in hand by click time,
    // making even the first open feel instant. Fires at most once.
    function warmCart() {
      if (!cartWarmed) fetchAndRender();
      openBtn.removeEventListener("pointerenter", warmCart);
      openBtn.removeEventListener("focus", warmCart);
      openBtn.removeEventListener("touchstart", warmCart);
    }
    // On the cart page the drawer would only mirror the page already on
    // screen, so the bag icon is left as the plain link to routes.cart_url
    // it is in the markup — no preventDefault, no drawer. The rest of the
    // drawer still initialises: the page's cross-sell can add to the bag and
    // goes through BS_openCartDrawer/BS_refreshCart.
    var onCartPage = document.body.classList.contains("template-cart");

    if (!onCartPage) {
      openBtn.addEventListener("pointerenter", warmCart);
      openBtn.addEventListener("focus", warmCart);
      openBtn.addEventListener("touchstart", warmCart, { passive: true });

      openBtn.addEventListener("click", function (e) {
        e.preventDefault();
        // The bag icon toggles: a second click closes the open drawer rather
        // than re-opening it (the close button is the other way out). The
        // add-to-bag preview is not a click-open, so the icon opens it fully.
        if (drawer.classList.contains("is-open") && !drawer.dataset.previewing) {
          closeCartDrawer();
          return;
        }
        anchorEl = openBtn;
        delete drawer.dataset.previewing;
        openCartDrawer();
      });
    }
    if (closeBtn) closeBtn.addEventListener("click", closeCartDrawer);
    scrim.addEventListener("click", closeCartDrawer);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) closeCartDrawer();
    });

    // Click-only to open: hovering the icon used to pop the drawer open too,
    // which could trigger just from the pointer passing over it on the way
    // elsewhere. Click is the deliberate signal to open; warmCart above
    // still prefetches on hover so the click itself feels instant.
    //
    // On desktop, closing also follows any scroll (either direction) — there
    // the drawer is a popover anchored to the bag icon, not the page, so
    // scrolling would leave it floating over unrelated content instead of
    // tracking the icon. Skipped while a post-add preview's own
    // auto-dismiss timer is running.
    //
    // NOT on mobile: there the drawer is a full-width sheet that owns the
    // screen, and dismissing it out from under a shopper who so much as
    // nudged the page read as the bag randomly vanishing. It stays up until
    // the close button, the scrim or Escape dismisses it. The background is
    // scroll-locked while it's open anyway; this also covers the scroll
    // events iOS still emits from momentum/rubber-banding and address-bar
    // resizes despite that lock.
    window.addEventListener("scroll", function () {
      if (isCartSheet()) return;
      if (drawer.classList.contains("is-open") && !drawer.dataset.previewing) closeCartDrawer();
    }, { passive: true });

    body.addEventListener("click", function (e) {
      var line = e.target.closest("[data-cart-line]");
      if (!line) return;
      var key = line.dataset.lineKey;

      var qtyBtn = e.target.closest("[data-cart-qty]");
      if (qtyBtn) {
        if (qtyBtn.classList.contains("is-maxed")) return;
        var valEl = line.querySelector(".bs-cart-drawer-qty-val");
        var current = parseInt(valEl.textContent, 10) || 0;
        var next = current + parseInt(qtyBtn.dataset.cartQty, 10);
        if (next < 0) return;
        // Stepping down from one deletes the line — the button is showing a
        // bin at that point, so it has to run the same collapse the row's own
        // remove control uses rather than committing a plain quantity.
        if (next === 0) {
          removeLine(key, line);
          return;
        }
        changeLine(key, next);
        return;
      }

      if (e.target.closest("[data-cart-remove]")) {
        removeLine(key, line);
      }
    });

    // Proactively warm the bag a moment after load, during idle time, so the
    // first open renders instantly instead of flashing the spinner. The
    // intent-based warm above (touchstart) lands too close to the tap on
    // mobile to beat it there; this gets the data in hand well beforehand.
    var warmOnIdle = function () { if (!cartWarmed) fetchAndRender(); };
    if (window.requestIdleCallback) {
      requestIdleCallback(warmOnIdle, { timeout: 2000 });
    } else {
      setTimeout(warmOnIdle, 1200);
    }
  }

  /* ── Wishlist header count (site-wide) ─────────────────────
     #wishCount lives in the header (every page renders it), but the code
     that actually reads "bs_wishlist" from localStorage previously only
     existed inside listing.js/product.js/wishlist.js — each gated to its
     own template (see layout/theme.liquid). So the badge only ever updated
     on the PLP/search, PDP, or wishlist page itself; everywhere else
     (home, 404, landing pages, cart, ...) it stayed frozen at the
     server-rendered "0 hidden" default. This mirrors initCartDrawer's
     syncHeaderCount above, but for the wishlist badge, and runs on every
     page since blue-salon.js itself is loaded unconditionally. */
  function hydrateWishlistCount() {
    var count;
    try {
      count = (JSON.parse(localStorage.getItem("bs_wishlist") || "[]") || []).length;
    } catch (e) {
      count = 0;
    }
    document.querySelectorAll("#wishCount").forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ── Hero carousel ──────────────────────────────────────── */
  function initHero(heroSection) {
    if (!heroSection || heroSection.dataset.initialized) return;
    heroSection.dataset.initialized = "true";

    var slidesEl = heroSection.querySelector("[data-hero-slides]");
    var slides;
    try {
      slides = JSON.parse(slidesEl ? slidesEl.textContent : "[]");
    } catch (e) {
      slides = [];
    }
    if (!slides.length) return;

    var heroTitle = heroSection.querySelector("[data-hero-title]");
    var heroSub = heroSection.querySelector("[data-hero-sub]");
    var heroCta = heroSection.querySelector("[data-hero-cta]");
    var heroOverlayCta = heroSection.querySelector("[data-hero-overlay-cta]");
    var heroImg = heroSection.querySelector("[data-hero-img]");
    var heroSource = heroSection.querySelector("[data-hero-source]");
    var heroDots = heroSection.querySelector("[data-hero-dots]");
    var heroPrev = heroSection.querySelector("[data-hero-prev]");
    var heroNext = heroSection.querySelector("[data-hero-next]");
    var current = 0;
    var firstHeroRender = true;
    var heroImageTimer = null;

    function showSlide(i, instant) {
      var s = slides[i];
      heroSection.classList.toggle("is-full", !!s.full);
      if (!s.full) {
        if (heroTitle) heroTitle.textContent = s.heading || "";
        if (heroSub) heroSub.textContent = s.sub || "";
        if (heroCta) heroCta.textContent = s.cta || "";
      }
      /* The overlay button belongs to the artwork, not to the text panel, so
         it is re-pointed on every slide — full-bleed ones included, which are
         exactly the slides the panel above is skipped for. */
      if (heroOverlayCta) {
        var wantsOverlay = !!(s.ctaShow && s.cta);
        heroOverlayCta.hidden = !wantsOverlay;
        if (wantsOverlay) {
          heroOverlayCta.textContent = s.cta;
          heroOverlayCta.setAttribute("href", s.link || "#");
          heroOverlayCta.className =
            "bs-btn bs-hero-overlay-cta" +
            " bs-hero-overlay-cta--h-" + (s.ctaAlign || "center") +
            " bs-hero-overlay-cta--v-" + (s.ctaValign || "bottom") +
            (s.ctaStyle === "outline" ? " bs-hero-overlay-cta--outline" : "");
          heroOverlayCta.style.setProperty("--hero-overlay-cta-bg", s.ctaBg || "#ffffff");
          heroOverlayCta.style.setProperty("--hero-overlay-cta-fg", s.ctaFg || "#1c1c1c");
        }
      }
      if (heroImg) {
        clearTimeout(heroImageTimer);
        /* instant: the swipe has already slid the new artwork into the frame
           as a ghost, so the live <img> has to arrive under it in one step —
           the 360ms-delayed cross-fade below would blank the banner instead. */
        if (firstHeroRender || instant) {
          heroSection.classList.remove("is-image-transitioning");
          if (heroSource) heroSource.srcset = s.mobileImg || s.img;
          heroImg.src = s.img;
          heroImg.alt = s.heading || "";
        } else {
          heroSection.classList.add("is-image-transitioning");
          heroImageTimer = setTimeout(function () {
            heroImg.onload = function () {
              heroImg.onload = null;
              requestAnimationFrame(function () { heroSection.classList.remove("is-image-transitioning"); });
            };
            if (heroSource) heroSource.srcset = s.mobileImg || s.img;
            heroImg.src = s.img;
            heroImg.alt = s.heading || "";
            if (heroImg.complete) {
              heroImg.onload = null;
              requestAnimationFrame(function () { heroSection.classList.remove("is-image-transitioning"); });
            }
          }, 360);
        }
      }
      if (heroDots) {
        heroDots.querySelectorAll(".bs-hero-dot").forEach(function (dot, j) {
          dot.classList.toggle("is-active", j === i);
        });
      }
      firstHeroRender = false;
    }

    if (heroDots) {
      slides.forEach(function (_, i) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "bs-hero-dot" + (i === 0 ? " is-active" : "");
        dot.setAttribute("aria-label", "Go to slide " + (i + 1));
        dot.addEventListener("click", function () { goToSlide(i); resetAuto(); });
        heroDots.appendChild(dot);
      });
    }

    function goToSlide(i) {
      current = (i + slides.length) % slides.length;
      showSlide(current);
    }

    var heroTimer = null;
    function startAuto() {
      if (slides.length < 2) return;
      heroTimer = setInterval(function () { goToSlide(current + 1); }, 4000);
    }
    function resetAuto() {
      clearInterval(heroTimer);
      startAuto();
    }
    heroSection.addEventListener("mouseenter", function () { clearInterval(heroTimer); });
    heroSection.addEventListener("mouseleave", resetAuto);

    function openSlideLink() {
      /* A swipe ends on the image, so without this the release would also read
         as a tap and navigate to the slide the finger just dragged away from. */
      if (swipeSuppressClick) return;
      var link = slides[current].link;
      if (link) window.location.href = link;
    }
    if (heroImg) heroImg.addEventListener("click", openSlideLink);
    if (heroCta) heroCta.addEventListener("click", openSlideLink);
    /* A real <a>, so the browser navigates on its own — all this has to do is
       cancel the navigation when the "click" is really the end of a swipe. */
    if (heroOverlayCta) {
      heroOverlayCta.addEventListener("click", function (e) {
        if (swipeSuppressClick) e.preventDefault();
      });
    }

    if (heroPrev) heroPrev.addEventListener("click", function () { goToSlide(current - 1); resetAuto(); });
    if (heroNext) heroNext.addEventListener("click", function () { goToSlide(current + 1); resetAuto(); });

    /* ── Swipe ────────────────────────────────────────────
       The carousel swaps the src of a single <img> rather than scrolling a
       track of slides, so a swipe had no movement to show: it could only
       cross-fade once the finger was already lifted. Where the section has a
       media frame to work with, initHero wraps the live <picture> in a
       transform frame and parks a ghost of the neighbouring slide one
       frame-width out on each side — so a drag carries the next banner in
       under the thumb, and the release either commits it or springs back.
       Sections sharing this JS contract but not that markup (the promo hero)
       fall through to the threshold-only swipe further down. */
    var heroMedia = heroSection.querySelector(".bs-hero-media");
    var heroPicture = heroMedia && heroMedia.querySelector("picture");
    var swipeTrack = null;
    var swipeGhostPrev = null;
    var swipeGhostNext = null;
    var swipeSuppressClick = false;

    if (heroPicture && slides.length > 1) {
      swipeTrack = document.createElement("div");
      swipeTrack.className = "bs-hero-swipe";
      heroMedia.insertBefore(swipeTrack, heroPicture);
      swipeTrack.appendChild(heroPicture);
      swipeGhostPrev = document.createElement("img");
      swipeGhostPrev.className = "bs-hero-swipe-ghost bs-hero-swipe-ghost--prev";
      swipeGhostPrev.alt = "";
      swipeGhostPrev.setAttribute("aria-hidden", "true");
      swipeGhostNext = swipeGhostPrev.cloneNode(false);
      swipeGhostNext.className = "bs-hero-swipe-ghost bs-hero-swipe-ghost--next";
      swipeTrack.appendChild(swipeGhostPrev);
      swipeTrack.appendChild(swipeGhostNext);
    }

    if (swipeTrack) {
      var dragStartX = 0;
      var dragStartY = 0;
      var dragStartTime = 0;
      var dragDx = 0;
      var dragAxis = "";
      var dragging = false;
      var settleTimer = null;

      /* Which artwork the frame is actually showing at this width — the
         ghosts have to match what <source media="(max-width: 900px)"> picks
         for the live image, or the committed slide would change on landing. */
      function slideUrl(slide) {
        var mobile = window.matchMedia("(max-width: 900px)").matches;
        return (mobile && slide.mobileImg) ? slide.mobileImg : slide.img;
      }

      function frameWidth() {
        return swipeTrack.offsetWidth || heroSection.offsetWidth || 1;
      }

      function setFrameX(px) {
        swipeTrack.style.transform = px ? "translate3d(" + px + "px, 0, 0)" : "";
      }

      function beginDrag() {
        clearTimeout(settleTimer);
        swipeTrack.classList.remove("is-settling");
        var prevUrl = slideUrl(slides[(current - 1 + slides.length) % slides.length]);
        var nextUrl = slideUrl(slides[(current + 1) % slides.length]);
        if (swipeGhostPrev.getAttribute("src") !== prevUrl) swipeGhostPrev.src = prevUrl;
        if (swipeGhostNext.getAttribute("src") !== nextUrl) swipeGhostNext.src = nextUrl;
        heroSection.classList.add("is-swiping");
      }

      /* Land on `index`: the ghost is already filling the frame, so put the
         live image on that slide first and only drop the offset once it has
         decoded — reset the transform any earlier and the frame snaps back to
         a stale, or blank, live image for a frame or two. */
      function settleOn(index) {
        current = (index + slides.length) % slides.length;
        showSlide(current, true);
        var landed = false;
        function land() {
          if (landed) return;
          landed = true;
          swipeTrack.classList.remove("is-settling");
          heroSection.classList.remove("is-swiping");
          setFrameX(0);
        }
        if (heroImg && heroImg.decode) heroImg.decode().then(land, land);
        else if (!heroImg || heroImg.complete) land();
        else heroImg.addEventListener("load", land, { once: true });
        /* Decode can stall on a cold cache; the frame must not stay parked. */
        settleTimer = setTimeout(land, 260);
      }

      function releaseDrag(dx, velocity) {
        var width = frameWidth();
        var commit = Math.abs(dx) > width * 0.18 || (Math.abs(dx) > 32 && velocity > 0.45);
        /* is-swiping stays on through the release animation, not just the
           drag: it's what holds the mobile caption out of the way, and the
           caption belongs to the slide that lands, not the one leaving. */
        swipeTrack.classList.add("is-settling");
        if (commit) {
          var dir = dx < 0 ? 1 : -1;
          setFrameX(dir > 0 ? -width : width);
          settleTimer = setTimeout(function () { settleOn(current + dir); }, 330);
        } else {
          setFrameX(0);
          settleTimer = setTimeout(function () {
            swipeTrack.classList.remove("is-settling");
            heroSection.classList.remove("is-swiping");
          }, 330);
        }
        resetAuto();
      }

      heroSection.addEventListener("touchstart", function (event) {
        if (event.touches.length !== 1) return;
        dragging = true;
        dragAxis = "";
        dragDx = 0;
        dragStartX = event.touches[0].clientX;
        dragStartY = event.touches[0].clientY;
        dragStartTime = event.timeStamp;
        clearInterval(heroTimer);
      }, { passive: true });

      heroSection.addEventListener("touchmove", function (event) {
        if (!dragging || event.touches.length !== 1) return;
        var dx = event.touches[0].clientX - dragStartX;
        var dy = event.touches[0].clientY - dragStartY;
        /* Decide the gesture's axis once, from whichever way it opened. A
           vertical open belongs to the page scroll and is left alone. */
        if (!dragAxis) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          dragAxis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
          if (dragAxis === "x") beginDrag();
        }
        if (dragAxis !== "x") return;
        event.preventDefault();
        dragDx = dx;
        setFrameX(dx);
      }, { passive: false });

      function onTouchRelease(event) {
        if (!dragging) return;
        dragging = false;
        if (dragAxis !== "x") {
          resetAuto();
          return;
        }
        dragAxis = "";
        swipeSuppressClick = true;
        setTimeout(function () { swipeSuppressClick = false; }, 400);
        var elapsed = Math.max(event.timeStamp - dragStartTime, 1);
        releaseDrag(dragDx, Math.abs(dragDx) / elapsed);
      }
      heroSection.addEventListener("touchend", onTouchRelease, { passive: true });
      heroSection.addEventListener("touchcancel", onTouchRelease, { passive: true });
    } else {
      var touchStartX = 0;
      var touchStartY = 0;
      heroSection.addEventListener("touchstart", function (event) {
        if (!event.touches.length) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        clearInterval(heroTimer);
      }, { passive: true });
      heroSection.addEventListener("touchend", function (event) {
        if (!event.changedTouches.length) return;
        var deltaX = event.changedTouches[0].clientX - touchStartX;
        var deltaY = event.changedTouches[0].clientY - touchStartY;
        if (Math.abs(deltaX) >= 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
          goToSlide(current + (deltaX < 0 ? 1 : -1));
        }
        resetAuto();
      }, { passive: true });
      heroSection.addEventListener("touchcancel", resetAuto, { passive: true });
    }

    if (slides.length < 2) {
      if (heroPrev) heroPrev.hidden = true;
      if (heroNext) heroNext.hidden = true;
      if (heroDots) heroDots.hidden = true;
    }

    showSlide(0);
    startAuto();
  }

  /* ── Collection sliders: arrow-scrolled horizontal rows ─── */
  /* Drag-to-scroll for native horizontal rails. Mouse and pen use the custom
     drag interaction; touch stays browser-native for reliable momentum
     scrolling and normal vertical-page gesture detection on phones. */
  function initDragScroll(scroller) {
    if (!scroller || scroller.dataset.dragScrollInitialized) return;
    scroller.dataset.dragScrollInitialized = "true";

    var active = false;
    var lockedHorizontal = false;
    var dragged = false;
    var pointerId = null;
    var startX = 0;
    var startY = 0;
    var startScrollLeft = 0;
    var suppressClickUntil = 0;

    function finish() {
      if (!active) return;
      active = false;
      if (dragged) suppressClickUntil = Date.now() + 250;
      if (pointerId !== null && scroller.hasPointerCapture && scroller.hasPointerCapture(pointerId)) {
        scroller.releasePointerCapture(pointerId);
      }
      pointerId = null;
      lockedHorizontal = false;
      dragged = false;
      scroller.classList.remove("is-dragging");
    }

    scroller.addEventListener("pointerdown", function (event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (event.pointerType === "touch") return;
      active = true;
      lockedHorizontal = false;
      dragged = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      startScrollLeft = scroller.scrollLeft;
    });

    scroller.addEventListener("pointermove", function (event) {
      if (!active || event.pointerId !== pointerId) return;

      var deltaX = event.clientX - startX;
      var deltaY = event.clientY - startY;

      if (!lockedHorizontal) {
        if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < 5) return;
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          finish();
          return;
        }
        lockedHorizontal = true;
        dragged = true;
        scroller.classList.add("is-dragging");
        if (scroller.setPointerCapture) scroller.setPointerCapture(pointerId);
      }

      event.preventDefault();
      // Raw scrollLeft on purpose: a drag is physical, not directional. The
      // pointer moves the content by exactly as many pixels either way, and
      // that holds for RTL's negative range too - do not "fix" this one.
      scroller.scrollLeft = startScrollLeft - deltaX;
    });

    scroller.addEventListener("pointerup", finish);
    scroller.addEventListener("pointercancel", finish);
    scroller.addEventListener("lostpointercapture", finish);
    scroller.addEventListener("dragstart", function (event) {
      event.preventDefault();
    });
    scroller.addEventListener("click", function (event) {
      if (Date.now() >= suppressClickUntil) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  /* Centre the product-slider arrows on the product image instead of on the
     whole card. The arrows are absolutely positioned against the wrapper,
     so the CSS default (top:50%) centres them against image + brand + title
     + price + swatches — visually landing near the bottom of the photo. The
     text block's height varies by section (1- vs 2-line titles) and by
     breakpoint, so a hardcoded percentage would drift; measuring the media
     box is the only value that stays correct. Exposed as a custom property
     that .product-grid-slider-arrow consumes, falling back to 50%. */
  function alignProductSliderArrows(wrap) {
    var media = wrap.querySelector(".plp-card-media");
    if (!media) return;

    function apply() {
      var wr = wrap.getBoundingClientRect();
      var mr = media.getBoundingClientRect();
      // Offset, not just height/2: the scroller adds padding-top on mobile,
      // so the image doesn't start at the wrapper's top edge. clientTop
      // discounts any border, since `top` resolves against the padding box.
      var top = (mr.top - wr.top - wrap.clientTop) + mr.height / 2;
      // aspect-ratio gives the box a height before the lazy image loads, but
      // guard anyway so a 0 never overwrites a good value.
      if (mr.height > 0) wrap.style.setProperty("--plp-arrow-top", top + "px");
    }

    apply();
    window.addEventListener("resize", apply);

    var img = media.querySelector("img");
    if (img && !img.complete) img.addEventListener("load", apply, { once: true });
  }

  function initSlider(wrap) {
    if (wrap.dataset.initialized) return;
    wrap.dataset.initialized = "true";

    var scroller = wrap.querySelector("[data-bs-slider]");
    var prev = wrap.querySelector('[class*="slider-arrow-left"]');
    var next = wrap.querySelector('[class*="slider-arrow-right"]');
    if (!scroller || !prev || !next) return;

    function step() {
      var card = scroller.children[0];
      var cardW = card ? card.getBoundingClientRect().width : scroller.clientWidth * 0.8;
      var gap = parseFloat(window.getComputedStyle(scroller).columnGap) || 20;
      var perView = Math.max(1, Math.round(scroller.clientWidth / (cardW + gap)));
      return (cardW + gap) * perView;
    }
    function update() {
      var max = BS.rtl.max(scroller) - 2;
      var pos = BS.rtl.pos(scroller);
      prev.disabled = pos <= 2;
      next.disabled = pos >= max;
    }

    /* prev/next are reading order, not screen order: in RTL the "left" arrow
       still means the previous card, and BS.rtl.by turns that into the right
       physical direction. */
    prev.addEventListener("click", function () {
      BS.rtl.by(scroller, -step(), true);
    });
    next.addEventListener("click", function () {
      BS.rtl.by(scroller, step(), true);
    });
    scroller.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  /* ── Brands marquee: seamless auto-scroll ───────────────── */
  function initMarquee(grid) {
    if (!grid || grid.querySelector(".brands-marquee-track")) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll(".brand-item"));
    if (!items.length) return;

    var marqueeCopies = 4;
    var track = document.createElement("div");
    track.className = "brands-marquee-track";
    items.forEach(function (item) { track.appendChild(item); });

    // Extra copies guarantee enough native scroll range to reach the reset
    // point even when one brand set is narrower than the viewport.
    for (var copyIndex = 1; copyIndex < marqueeCopies; copyIndex += 1) {
      items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.setAttribute("tabindex", "-1");
        track.appendChild(clone);
      });
    }

    grid.textContent = "";
    grid.appendChild(track);

    var wrapper = grid.closest("[data-featured-brands-wrapper]");
    var prev = wrapper && wrapper.querySelector(".brands-slider-arrow-left");
    var next = wrapper && wrapper.querySelector(".brands-slider-arrow-right");
    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    var hoverCapable = window.matchMedia("(hover: hover) and (pointer: fine)");
    var pointerDown = false;
    var hovering = false;
    var keyboardFocused = false;
    var inView = true;
    var pauseUntil = 0;
    var lastFrame = 0;

    function loopWidth() {
      return track.scrollWidth / marqueeCopies;
    }

    function pauseTemporarily(duration) {
      pauseUntil = Math.max(pauseUntil, Date.now() + duration);
    }

    function hasVisibleFocus(element) {
      if (!element || !element.matches) return false;
      try {
        return element.matches(":focus-visible");
      } catch (error) {
        return false;
      }
    }

    function normalize() {
      var loop = loopWidth();
      var pos = BS.rtl.pos(grid);
      if (loop && pos >= loop) BS.rtl.setPos(grid, pos % loop);
    }

    function step() {
      var item = track.querySelector(".brand-item");
      if (!item) return grid.clientWidth * 0.75;
      var styles = window.getComputedStyle(item);
      var marginEnd = parseFloat(styles.marginInlineEnd || styles.marginRight) || 0;
      var outerWidth = item.getBoundingClientRect().width + marginEnd;
      var visible = Math.max(1, Math.floor(grid.clientWidth / outerWidth) - 1);
      var maxUniqueStep = Math.max(outerWidth, loopWidth() - outerWidth);
      return Math.min(outerWidth * visible, maxUniqueStep);
    }

    function move(direction) {
      var amount = step();
      var loop = loopWidth();
      pauseTemporarily(450);
      if (direction < 0 && BS.rtl.pos(grid) < amount && loop) {
        BS.rtl.setPos(grid, BS.rtl.pos(grid) + loop);
      }
      BS.rtl.by(grid, direction * amount, !reducedMotion.matches);
    }

    if (prev) {
      prev.disabled = false;
      prev.addEventListener("click", function () { move(-1); });
    }
    if (next) {
      next.disabled = false;
      next.addEventListener("click", function () { move(1); });
    }

    grid.addEventListener("mouseenter", function () {
      if (hoverCapable.matches) hovering = true;
    });
    grid.addEventListener("mouseleave", function () {
      hovering = false;
    });
    grid.addEventListener("focusin", function (event) {
      keyboardFocused = hasVisibleFocus(event.target);
    });
    grid.addEventListener("focusout", function (event) {
      keyboardFocused = Boolean(
        event.relatedTarget &&
        grid.contains(event.relatedTarget) &&
        hasVisibleFocus(event.relatedTarget)
      );
    });
    grid.addEventListener("pointerdown", function () {
      pointerDown = true;
      keyboardFocused = false;
      // Keep the pressed logo stationary until the tap or drag ends. Jumping
      // to a duplicate here can cancel the first link click on touch screens.
    });

    function finishPointerInteraction() {
      if (!pointerDown) return;
      pointerDown = false;
    }

    grid.addEventListener("pointerup", finishPointerInteraction);
    grid.addEventListener("pointercancel", finishPointerInteraction);
    window.addEventListener("pointerup", finishPointerInteraction);
    window.addEventListener("pointercancel", finishPointerInteraction);
    window.addEventListener("blur", finishPointerInteraction);
    grid.addEventListener("wheel", function () {
      pauseTemporarily(350);
    }, { passive: true });

    var observer = null;
    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(function (entries) {
        inView = Boolean(entries[0] && entries[0].isIntersecting);
      }, { threshold: 0.05 });
      observer.observe(grid);
    }

    function autoScroll(timestamp) {
      if (!grid.isConnected) {
        if (observer) observer.disconnect();
        return;
      }
      var elapsed = lastFrame ? Math.min(timestamp - lastFrame, 50) : 0;
      var canMove = inView &&
        !reducedMotion.matches &&
        !hovering &&
        !keyboardFocused &&
        !pointerDown &&
        !grid.classList.contains("is-dragging") &&
        Date.now() >= pauseUntil;

      if (canMove && grid.scrollWidth > grid.clientWidth) {
        BS.rtl.setPos(grid, BS.rtl.pos(grid) + elapsed * 0.045);
        normalize();
      }

      lastFrame = timestamp;
      window.requestAnimationFrame(autoScroll);
    }

    window.requestAnimationFrame(autoScroll);
  }

  /* ── Brands directory: A-Z fetched brand grid, filterable by department ── */
  var BRANDS_GENDER_FACET_ID = "237954416";
  var BRANDS_TABS = [
    { key: "all", label: "All", tags: null },
    { key: "women", label: "Women", tags: ["Womens", "Unisex"] },
    { key: "men", label: "Men", tags: ["Unisex", "Mens"] },
    { key: "boys", label: "Boys", tags: ["Boys"] },
    { key: "girls", label: "Girls", tags: ["Girls"] }
  ];
  /* Departments a page can be locked to (brands-directory "Department"
     setting, e.g. templates/page.beauty-brands.json): that page lists only
     the department's brands, with no tabs and no ?category= switching. */
  var BRANDS_FIXED = {
    beauty: { key: "beauty", label: "Beauty", tags: ["Beauty"] }
  };

  function initBrandsDirectory(root) {
    if (!root || root.dataset.brandsInited) return;
    root.dataset.brandsInited = "true";

    var groupsEl = root.querySelector("[data-brands-groups]");
    var loadingEl = root.querySelector("[data-brands-loading]");
    var emptyEl = root.querySelector("[data-brands-empty]");
    var azEl = root.querySelector("[data-brands-az]");
    var tabsEl = root.querySelector("[data-brands-tabs]");
    var searchEl = root.querySelector("[data-brands-search]");
    var searchClearEl = root.querySelector("[data-brands-search-clear]");
    var apiUrl = root.getAttribute("data-api-url");
    var imageBase = root.getAttribute("data-image-base") || "";
    var skeletonHtml = loadingEl ? loadingEl.outerHTML : "";
    var emptyDefault = emptyEl ? emptyEl.textContent : "";

    /* Brands for the active tab, kept unfiltered so typing in the search box
       narrows them client-side instead of re-hitting the API per keystroke. */
    var tabBrands = [];
    var query = "";

    if (!apiUrl) return;

    /* ── Deep-linkable category tabs: ?category=women/men/boys/girls ──
       Read on load so a shared/bookmarked link opens straight into that
       department; written back (via replaceState, not push) on every tab
       click so the current view stays copy-able without spamming browser
       history for what is just a filter, not a navigation. */
    function readTabFromUrl() {
      try {
        var params = new URLSearchParams(window.location.search);
        var key = (params.get("category") || "").toLowerCase();
        for (var i = 0; i < BRANDS_TABS.length; i++) {
          if (BRANDS_TABS[i].key === key) return BRANDS_TABS[i];
        }
      } catch (e) { /* no-op — URLSearchParams unsupported, fall through */ }
      return BRANDS_TABS[0];
    }

    function writeTabToUrl(tab) {
      try {
        var url = new URL(window.location.href);
        if (tab.key === "all") {
          url.searchParams.delete("category");
        } else {
          url.searchParams.set("category", tab.key);
        }
        window.history.replaceState(window.history.state, "", url);
      } catch (e) { /* no-op — URL API unsupported */ }
    }

    function brandHandle(label) {
      return String(label || "").trim().replace(/\s+/g, "-").toLowerCase();
    }

    function brandsUrl(tags) {
      if (!tags) return apiUrl;
      var filters = {};
      filters[BRANDS_GENDER_FACET_ID] = ["tags", tags];
      return apiUrl + "&facetFilters=" + encodeURIComponent(JSON.stringify(filters));
    }

    // Brands with their own collection link there (sections/brands-directory
    // renders the map); the rest keep the vendor search page.
    var brandCollections = {};
    try {
      var brandMapEl = document.querySelector("[data-brand-collections]");
      if (brandMapEl) brandCollections = JSON.parse(brandMapEl.textContent) || {};
    } catch (e) {
      brandCollections = {};
    }

    function retrieveBrands(url, base) {
      return fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (apiData) {
          var labels = (apiData && apiData.data && apiData.data.facets && apiData.data.facets[1] && apiData.data.facets[1].labels) || [];
          // One tile per brand. Product data spells some vendors two ways
          // ("BUGATTI" on 1 product, "Bugatti" on 85; "Mercedes Benz" /
          // "Mercedes-Benz"; "Estée" / "Estee") and the search app lists each
          // spelling as its own brand. They are merged on letters and digits
          // alone - case, accents, spaces and hyphens ignored - and shown in
          // the spelling most products use.
          var byKey = {};
          labels.forEach(function (b) {
            var label = String(b.label || "").trim();
            if (!label) return;
            var key = label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "") || label.toLowerCase();
            var seen = byKey[key];
            if (!seen) {
              byKey[key] = { label: label, value: b.value || 0, top: b.value || 0, spellings: [label.toLowerCase()] };
            } else {
              seen.spellings.push(label.toLowerCase());
              if ((b.value || 0) > seen.top) {
                seen.label = label;
                seen.top = b.value || 0;
              }
              seen.value += b.value || 0;
            }
          });
          return Object.keys(byKey)
            .map(function (key) {
              var b = byKey[key];
              var handle = brandHandle(b.label);
              // The collection map is keyed by each spelling; any of them will do.
              var collection = null;
              b.spellings.forEach(function (s) { if (!collection && brandCollections[s]) collection = brandCollections[s]; });
              return {
                label: b.label,
                value: b.value,
                handle: handle,
                image: base + handle + ".jpg",
                url: BS.storefrontUrl(collection || ("collections/vendors?q=" + encodeURIComponent(b.label)))
              };
            })
            .sort(function (a, c) { return a.label.localeCompare(c.label); });
        });
    }

    function applyFilter() {
      var q = query.trim().toLowerCase();
      if (emptyEl) {
        emptyEl.textContent = q
          ? ((window.BS_I18N || {}).no_designers_match || 'No designers match "__QUERY__".').replace('__QUERY__', function () { return query.trim(); })
          : emptyDefault;
      }
      if (!q) return renderBrands(tabBrands);
      renderBrands(tabBrands.filter(function (brand) {
        return brand.label.toLowerCase().indexOf(q) !== -1;
      }));
    }

    function loadTab(tab) {
      if (emptyEl) emptyEl.hidden = true;
      if (groupsEl) groupsEl.innerHTML = skeletonHtml;

      retrieveBrands(brandsUrl(tab.tags), imageBase)
        .then(function (brands) { tabBrands = brands; })
        .catch(function () { tabBrands = []; })
        .then(function () { applyFilter(); });
    }

    function initSearch() {
      if (!searchEl) return;
      var timer = null;

      function sync() {
        query = searchEl.value;
        if (searchClearEl) searchClearEl.hidden = !query;
        clearTimeout(timer);
        // Short debounce so a fast typist doesn't re-render the grid per keystroke.
        timer = setTimeout(applyFilter, 120);
      }

      searchEl.addEventListener("input", sync);
      searchEl.addEventListener("keydown", function (event) {
        if (event.key !== "Escape" || !searchEl.value) return;
        event.preventDefault();
        searchEl.value = "";
        sync();
      });

      if (searchClearEl) {
        searchClearEl.addEventListener("click", function () {
          searchEl.value = "";
          sync();
          searchEl.focus();
        });
      }
    }

    initSearch();

    function renderTabs(activeTab) {
      if (!tabsEl) return;
      tabsEl.textContent = "";
      BRANDS_TABS.forEach(function (tab) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "brands-directory-tab" + (tab.key === activeTab.key ? " is-active" : "");
        btn.textContent = (window.BS_I18N || {})[tab.key] || tab.label;
        btn.addEventListener("click", function () {
          if (btn.classList.contains("is-active")) return;
          Array.prototype.forEach.call(tabsEl.querySelectorAll(".brands-directory-tab"), function (el) {
            el.classList.remove("is-active");
          });
          btn.classList.add("is-active");
          writeTabToUrl(tab);
          loadTab(tab);
        });
        tabsEl.appendChild(btn);
      });
    }

    var fixedTab = BRANDS_FIXED[root.getAttribute("data-brands-department") || ""];
    if (fixedTab) {
      if (tabsEl) tabsEl.hidden = true;
      loadTab(fixedTab);
    } else {
      var initialTab = readTabFromUrl();
      renderTabs(initialTab);
      loadTab(initialTab);
    }

    function renderBrands(brands) {
      var loading = groupsEl ? groupsEl.querySelector("[data-brands-loading]") : null;
      if (loading) loading.remove();

      if (!brands.length) {
        if (groupsEl) groupsEl.textContent = "";
        if (azEl) azEl.textContent = "";
        if (emptyEl) emptyEl.hidden = false;
        return;
      }

      var groups = {};
      var letters = [];
      brands.forEach(function (brand) {
        var first = brand.label.charAt(0).toUpperCase();
        var letter = /[A-Z]/.test(first) ? first : "#";
        if (!groups[letter]) {
          groups[letter] = [];
          letters.push(letter);
        }
        groups[letter].push(brand);
      });
      letters.sort();

      if (azEl) {
        azEl.textContent = "";
        letters.forEach(function (letter) {
          var link = document.createElement("a");
          link.href = "#brands-letter-" + letter;
          link.className = "brands-directory-az-link";
          link.textContent = letter;
          azEl.appendChild(link);
        });
      }

      if (groupsEl) {
        groupsEl.textContent = "";
        letters.forEach(function (letter) {
          var group = document.createElement("div");
          group.className = "brands-directory-group";
          group.id = "brands-letter-" + letter;

          var title = document.createElement("h2");
          title.className = "brands-directory-group-title";
          title.textContent = letter;
          group.appendChild(title);

          var grid = document.createElement("div");
          grid.className = "brands-directory-grid";

          groups[letter].forEach(function (brand) {
            var card = document.createElement("a");
            card.className = "brands-directory-card";
            card.href = brand.url;
            card.title = brand.label;

            var logo = document.createElement("span");
            logo.className = "brands-directory-logo";

            var img = document.createElement("img");
            img.src = brand.image;
            img.alt = brand.label;
            img.loading = "lazy";
            img.addEventListener("error", function () {
              var fallback = document.createElement("span");
              fallback.className = "brands-directory-fallback";
              fallback.textContent = brand.label;
              logo.textContent = "";
              logo.appendChild(fallback);
            }, { once: true });

            logo.appendChild(img);
            card.appendChild(logo);
            grid.appendChild(card);
          });

          group.appendChild(grid);
          groupsEl.appendChild(group);
        });
      }
    }
  }

  /* ── Track order: lookup by order number + email, shows a
     status timeline modal on success. ─────────────────────── */
  function initTrackOrder(root) {
    if (!root || root.dataset.trackInited) return;
    root.dataset.trackInited = "true";

    // Copy for the strings this widget builds at runtime. Published by
    // snippets/storefront-i18n.liquid, since a .js asset is not a translatable
    // resource and cannot read the locale files itself. English literals stay as
    // the fallback so the widget still reads correctly if the bridge is absent.
    var T = (window.BS_I18N || {}).track_order || {};

    var form = root.querySelector("[data-track-order-form]");
    var submitBtn = root.querySelector("[data-track-order-submit]");
    var submitLabel = submitBtn ? submitBtn.querySelector(".track-order-submit-label") : null;
    var errorEl = root.querySelector("[data-track-order-error]");
    var orderInput = root.querySelector("#TrackOrderNumber");
    var emailInput = root.querySelector("#TrackOrderEmail");
    var apiUrl = root.getAttribute("data-api-url");
    var platform = root.getAttribute("data-platform") || "";

    var section = root.closest(".track-order") || document;
    var scrim = section.querySelector("[data-track-order-scrim]");
    var modal = section.querySelector("[data-track-order-modal]");
    var closeBtn = section.querySelector("[data-track-order-close]");
    var numberEl = section.querySelector("[data-track-order-number]");
    var statusEl = section.querySelector("[data-track-order-status]");
    var timelineEl = section.querySelector("[data-track-order-timeline]");

    if (!form || !apiUrl) return;

    function statusText(entry, keys, fallback) {
      for (var i = 0; i < keys.length; i++) {
        var value = entry && entry[keys[i]];
        if (typeof value === "string" && value.trim()) return value.trim();
      }
      return fallback || "";
    }

    function openModal() {
      scrim.hidden = false;
      modal.hidden = false;
      void modal.offsetWidth;
      scrim.classList.add("is-open");
      modal.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }

    function closeModal() {
      scrim.classList.remove("is-open");
      modal.classList.remove("is-open");
      document.body.style.overflow = "";
      var onEnd = function () {
        scrim.hidden = true;
        modal.hidden = true;
        modal.removeEventListener("transitionend", onEnd);
      };
      modal.addEventListener("transitionend", onEnd);
    }

    function setLoading(isLoading) {
      if (submitBtn) submitBtn.disabled = isLoading;
      if (submitLabel) submitLabel.textContent = isLoading
        ? (T.checking || "Checking…")
        : (T.submit || "Track order");
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = !message;
    }

    function renderTimeline(statuses, currentStatus) {
      if (!timelineEl) return;
      timelineEl.textContent = "";

      var current = (currentStatus || "").trim();
      var currentIndex = -1;
      statuses.forEach(function (entry, index) {
        if (statusText(entry, ["status_name", "title", "name", "label"]) === current) currentIndex = index;
      });

      statuses.forEach(function (entry, index) {
        var item = document.createElement("li");
        item.className = "track-order-timeline-item";
        if (currentIndex >= 0 && index < currentIndex) item.classList.add("is-done");
        if (index === currentIndex) item.classList.add("is-current");

        var label = document.createElement("span");
        label.className = "track-order-timeline-label";
        label.textContent = statusText(
          entry,
          ["status_name", "title", "name", "label"],
          (T.update_n || "Update __N__").replace("__N__", index + 1)
        );
        item.appendChild(label);

        var date = statusText(entry, ["date", "time", "timestamp", "datetime", "created_at"]);
        if (date) {
          var dateEl = document.createElement("span");
          dateEl.className = "track-order-timeline-date";
          dateEl.textContent = date;
          item.appendChild(dateEl);
        }

        var desc = statusText(entry, ["description", "message", "note"]);
        if (desc) {
          var descEl = document.createElement("p");
          descEl.className = "track-order-timeline-desc";
          descEl.textContent = desc;
          item.appendChild(descEl);
        }

        timelineEl.appendChild(item);
      });
    }

    function getOrderStatus(orderNumber, email) {
      showError("");
      setLoading(true);

      var body = new URLSearchParams();
      body.append("order_id", orderNumber);
      body.append("email", email);
      body.append("platform", platform);

      fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body
      })
        .then(function (res) { return res.json(); })
        .then(function (result) {
          setLoading(false);
          if (result && result.status_code === 100 && result.data) {
            if (numberEl) numberEl.textContent = result.data.order_number || orderNumber;
            if (statusEl) statusEl.textContent = result.data.current_status || "";
            renderTimeline(result.data.statuses || [], result.data.current_status);
            openModal();
          } else {
            showError((result && result.message) || T.not_found ||
              "We couldn't find that order. Please check your details and try again.");
          }
        })
        .catch(function () {
          setLoading(false);
          showError(T.error_generic ||
            "Something went wrong while checking your order. Please try again.");
        });
    }

    var params = new URLSearchParams(location.search);
    var paramOrder = params.get("order");
    var paramEmail = params.get("mail");
    if (paramOrder && paramEmail) {
      if (orderInput) orderInput.value = paramOrder;
      if (emailInput) emailInput.value = paramEmail;
      getOrderStatus(paramOrder, paramEmail);
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var orderNumber = orderInput ? orderInput.value.trim() : "";
      var email = emailInput ? emailInput.value.trim() : "";
      if (!orderNumber || !email) {
        showError(T.error_required || "Please fill out all required fields and try again.");
        return;
      }
      getOrderStatus(orderNumber, email);
    });

    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    if (scrim) scrim.addEventListener("click", closeModal);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("is-open")) closeModal();
    });
  }

  /* ── Book a fitting room: floor the date picker at today so guests
     can't request a past appointment. Submission itself is a plain
     Shopify contact-form POST, no JS needed. ── */
  function initFittingAppointmentDate() {
    var input = document.querySelector("[data-fit-appt-date]");
    if (!input || input.dataset.fitDateInited) return;
    input.dataset.fitDateInited = "true";

    var today = new Date();
    var min = today.getFullYear() + "-" +
      String(today.getMonth() + 1).padStart(2, "0") + "-" +
      String(today.getDate()).padStart(2, "0");
    input.setAttribute("min", min);
  }

  /* ── Register page: searchable country-code combobox for the Mobile
     number field — a custom button + filterable listbox instead of a
     plain <select>, since native selects can't be searched. Selecting an
     option writes into the #RegisterMobileCode hidden input that
     initRegisterPhoneTag below reads. ── */
  function initPhoneCodeCombobox() {
    var field = document.getElementById("RegisterMobileCodeField");
    var btn = document.getElementById("RegisterMobileCodeBtn");
    var abbrEl = document.getElementById("RegisterMobileCodeAbbr");
    var dialEl = document.getElementById("RegisterMobileCodeDial");
    var btnFlag = document.getElementById("RegisterMobileCodeFlag");
    var panel = document.getElementById("RegisterMobileCodePanel");
    var search = document.getElementById("RegisterMobileCodeSearch");
    var list = document.getElementById("RegisterMobileCodeList");
    var empty = document.getElementById("RegisterMobileCodeEmpty");
    var hiddenCode = document.getElementById("RegisterMobileCode");
    if (!field || !btn || !abbrEl || !dialEl || !panel || !search || !list || !hiddenCode || field.dataset.initialized) return;
    field.dataset.initialized = "true";

    var options = Array.prototype.slice.call(list.querySelectorAll(".bs-phone-code-option"));

    // Same fallback for the closed control: hide the image and let the short
    // code that sits behind it show through, so the button never goes blank.
    if (btnFlag) {
      btnFlag.addEventListener("error", function () {
        btn.classList.add("is-flagless");
      });
      if (btnFlag.complete && btnFlag.naturalWidth === 0) btn.classList.add("is-flagless");
    }

    // Flags are remote images, so treat them as decoration that may not
    // arrive: a blocked or failed request leaves the row's country name and
    // dial code doing the work, with the ISO letters standing in for the
    // artwork.
    function lettersInsteadOfFlag(img) {
      var stand = document.createElement("span");
      stand.className = "bs-phone-code-flag bs-phone-code-flag-fallback";
      stand.textContent = img.dataset.iso || "";
      stand.setAttribute("aria-hidden", "true");
      img.replaceWith(stand);
    }

    // Capture phase, because error does not bubble.
    list.addEventListener("error", function (e) {
      var img = e.target;
      if (!img.classList || !img.classList.contains("bs-phone-code-flag")) return;
      lettersInsteadOfFlag(img);
    }, true);

    // The listener above only catches failures from here on, and it is
    // routinely too late: the panel starts out `hidden`, which gives these
    // images no layout box to be lazy about, so Chrome requests them during
    // parse and a dead host fails them before this deferred script runs at
    // all. Sweep for the ones that already lost the race. complete && no
    // natural width is specifically "finished and broken" — images still in
    // flight report complete === false and are left to the listener.
    options.forEach(function (opt) {
      var img = opt.querySelector("img.bs-phone-code-flag");
      if (img && img.complete && img.naturalWidth === 0) lettersInsteadOfFlag(img);
    });

    function visibleOptions() {
      return options.filter(function (o) { return !o.hidden; });
    }

    function closePanel() {
      panel.hidden = true;
      btn.setAttribute("aria-expanded", "false");
    }

    // The Mobile number row often sits near the bottom of the viewport, where
    // a panel that always drops downward gets clipped by the window edge —
    // search box and list both out of reach. Measure the room on each side
    // and flip upward when there is more of it, then cap the scrolling list
    // (not the search box) to whatever is actually available.
    // Below 640px the panel is a fixed bottom sheet (see the media query on
    // .bs-phone-code-panel in blue-salon.css), so none of the popover
    // geometry below applies — and running it there was itself the bug:
    // it flipped the panel above a field near the bottom of a phone
    // screen, which pushed the search box off the top edge.
    function isSheet() {
      return window.matchMedia && window.matchMedia("(max-width: 640px)").matches;
    }

    /* keepSide: true while the panel is already open (scroll, resize). The
       panel then stays on the side it is on for as long as it still fits
       there, and moves only when it no longer does and the other side has
       more room. Without that, the "which side has more room?" test flips
       the panel every time the field crosses the middle of the screen, so a
       slow scroll near the midpoint flickers it above/below/above. */
    function positionPanel(keepSide) {
      var wasAbove = panel.classList.contains("is-above");
      panel.classList.remove("is-above");
      list.style.maxHeight = "";
      if (isSheet()) return;

      // The designed size, read with the inline cap cleared so it is the
      // stylesheet's value (.bs-phone-code-list max-height, ten rows). This
      // is a ceiling: the room around the field may shorten the list, never
      // lengthen it. Writing the room straight in, as this used to, made the
      // panel as tall as the window allowed — so its size depended on the
      // shopper's screen rather than on the design.
      var designMax = parseFloat(window.getComputedStyle(list).maxHeight);
      if (!isFinite(designMax)) designMax = Infinity;

      var rect = btn.getBoundingClientRect();
      var gap = 12;
      var below = window.innerHeight - rect.bottom - gap;
      var above = rect.top - gap;
      // Measured at the designed size, so "does it fit?" asks about the
      // panel the shopper will actually see.
      var need = panel.offsetHeight;

      var goAbove;
      if (keepSide) {
        var here = wasAbove ? above : below;
        var there = wasAbove ? below : above;
        goAbove = (here >= need || here >= there) ? wasAbove : !wasAbove;
      } else {
        goAbove = need > below && above > below;
      }
      if (goAbove) panel.classList.add("is-above");

      var room = goAbove ? above : below;
      // Everything in the panel that isn't the scrolling list — search box,
      // padding, borders — has to keep its height, so only the list gives.
      var chrome = panel.offsetHeight - list.offsetHeight;
      list.style.maxHeight = Math.max(120, Math.min(designMax, room - chrome)) + "px";
    }

    function openPanel() {
      panel.hidden = false;
      btn.setAttribute("aria-expanded", "true");
      search.value = "";
      filterOptions("");
      positionPanel();
      // On a phone, focusing the search raises the on-screen keyboard over
      // the sheet before the shopper has even seen the list — most people
      // scroll to their country rather than type it. Let them tap the box
      // if they want to type.
      if (!isSheet()) search.focus();
    }

    function filterOptions(query) {
      var q = query.trim().toLowerCase();
      var shown = 0;
      options.forEach(function (opt) {
        // data-search carries the English name: the visible label is translated,
        // so matching on textContent alone would drop English queries.
        // data-abbr is in the haystack too — the closed control reads "KSA" /
        // "UAE", so that is what a shopper types back at it, and those letters
        // are no longer part of the row's own text.
        var haystack = (opt.textContent + " " + (opt.dataset.search || "") +
          " " + (opt.dataset.abbr || "") + " " + opt.dataset.code).toLowerCase();
        opt.hidden = q !== "" && haystack.indexOf(q) === -1;
        if (!opt.hidden) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    }

    function selectOption(opt) {
      hiddenCode.value = opt.dataset.code;
      // initRegisterPhoneField listens for this: the expected number length
      // depends on the dial code, so an already-typed number has to be
      // re-checked whenever the country changes.
      hiddenCode.dispatchEvent(new Event("change", { bubbles: true }));
      abbrEl.textContent = opt.dataset.abbr || "";
      dialEl.textContent = opt.dataset.code;
      // Copy the row's own flag rather than rebuilding the URL from an ISO
      // code: the browser has already fetched that exact image for the list,
      // so the closed control swaps to it without a second request.
      var rowFlag = opt.querySelector("img.bs-phone-code-flag");
      if (btnFlag && rowFlag) {
        btnFlag.src = rowFlag.src;
        btnFlag.srcset = rowFlag.srcset;
        btn.classList.remove("is-flagless");
      } else if (btnFlag) {
        // The row's flag had already failed and been swapped for letters.
        btn.classList.add("is-flagless");
      }
      // The button's own text is two terse fragments ("UAE", "+971"), so name
      // the selection in full for anyone hearing it rather than reading it.
      var name = opt.querySelector(".bs-phone-code-option-name");
      btn.setAttribute("aria-label", (name ? name.textContent.trim() + " " : "") + opt.dataset.code);
      options.forEach(function (o) {
        var isMatch = o === opt;
        o.classList.toggle("is-selected", isMatch);
        o.setAttribute("aria-selected", isMatch ? "true" : "false");
      });
      closePanel();
      btn.focus();
    }

    btn.addEventListener("click", function () {
      if (panel.hidden) openPanel(); else closePanel();
    });

    search.addEventListener("input", function () {
      filterOptions(search.value);
    });

    search.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closePanel();
        btn.focus();
      } else if (e.key === "Enter") {
        e.preventDefault();
        var first = visibleOptions()[0];
        if (first) selectOption(first);
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        var firstVisible = visibleOptions()[0];
        if (firstVisible) firstVisible.focus();
      }
    });

    list.addEventListener("click", function (e) {
      var opt = e.target.closest(".bs-phone-code-option");
      if (opt) selectOption(opt);
    });

    options.forEach(function (opt) {
      opt.addEventListener("keydown", function (e) {
        var visible = visibleOptions();
        var idx = visible.indexOf(opt);
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          selectOption(opt);
        } else if (e.key === "Escape") {
          closePanel();
          btn.focus();
        } else if (e.key === "ArrowDown") {
          e.preventDefault();
          if (idx > -1 && idx < visible.length - 1) visible[idx + 1].focus();
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          if (idx > 0) visible[idx - 1].focus();
          else search.focus();
        }
      });
    });

    document.addEventListener("click", function (e) {
      if (panel.hidden || !e.target.isConnected) return; // see initAccountDropdown
      if (!field.contains(e.target)) closePanel();
    });

    /* Re-placed as the page scrolls, so the panel answers in both
       directions: opened upward near the bottom of the screen, scrolling
       down shrinks the room above until the search box would be clipped off
       the top — at that point it moves below the field, and back again on
       the way up.

       This handler used to be the bug rather than the fix. Its height cap
       was "all the room there is", and once the field scrolled off the top
       of the screen the room below it read as the whole window plus every
       pixel scrolled — so the list grew with the scroll (measured: 245px at
       open, 1,673px by the footer) with its bottom pinned to the screen,
       hanging over the footer while its field was a thousand pixels away.
       That is fixed in positionPanel by the stylesheet's ten-row ceiling, not
       by switching repositioning off: with the ceiling the panel cannot grow,
       and without repositioning it cannot get out of the way of the window
       edge, which was the half of the bug this handler existed to prevent.

       Throttled to one pass per frame — a wheel or trackpad fires scroll far
       more often than the screen repaints, and every pass forces layout.

       Not "close on scroll", the native <select> answer: arrow-key
       navigation calls .focus() on each option, which scrolls the window
       when the panel is partly off-screen, and openPanel focuses the search
       box — so closing on scroll would shut the list under a keyboard user
       mid-selection, and could shut it the moment it opened. */
    var placeQueued = false;
    function queuePlace() {
      if (panel.hidden || placeQueued) return;
      placeQueued = true;
      window.requestAnimationFrame(function () {
        placeQueued = false;
        if (!panel.hidden) positionPanel(true);
      });
    }
    window.addEventListener("scroll", queuePlace, { passive: true });
    window.addEventListener("resize", queuePlace);
  }

  /* ── Register page: Mobile number validation. The field used to accept
     anything at all — letters, punctuation, a run of spaces — and still
     create the account, because Shopify's create_customer form has no
     validation for it (the number isn't even a real form field here; see
     initRegisterPhoneTag below). Three guards, all client-side because
     that's the only layer this form has:
       1. keep the value digits-only as it's typed or pasted,
       2. check the digit count against the selected dial code,
       3. block submit and explain inline rather than failing silently.
     PHONE_LENGTHS is [min, max] national-number digits per dial code, for
     the markets Blue Salon actually ships to plus the common expat home
     countries. Anything not listed falls back to E.164's own bounds, which
     still rejects "abcd", a blank, and a 2-digit typo. ── */
  var PHONE_LENGTHS = {
    "+974": [8, 8],   "+971": [9, 9],   "+966": [9, 9],   "+965": [8, 8],
    "+973": [8, 8],   "+968": [8, 8],   "+962": [9, 9],   "+961": [7, 8],
    "+964": [10, 10], "+967": [9, 9],   "+970": [9, 9],   "+963": [9, 9],
    "+20": [10, 10],  "+212": [9, 9],   "+213": [9, 9],
    "+216": [8, 8],   "+218": [9, 9],   "+249": [9, 9],   "+234": [10, 10],
    "+254": [9, 9],   "+27": [9, 9],    "+1": [10, 10],   "+44": [10, 10],
    "+33": [9, 9],    "+49": [10, 11],  "+39": [9, 10],   "+34": [9, 9],
    "+31": [9, 9],    "+32": [8, 9],    "+41": [9, 9],    "+43": [10, 13],
    "+45": [8, 8],    "+46": [7, 9],    "+47": [8, 8],    "+48": [9, 9],
    "+30": [10, 10],  "+351": [9, 9],   "+353": [7, 9],   "+358": [6, 10],
    "+40": [9, 9],    "+420": [9, 9],   "+7": [10, 10],   "+90": [10, 10],
    "+98": [10, 10],  "+91": [10, 10],  "+92": [10, 10],  "+880": [10, 10],
    "+94": [9, 9],    "+977": [10, 10], "+63": [10, 10],  "+62": [9, 12],
    "+60": [9, 10],   "+65": [8, 8],    "+66": [9, 9],    "+84": [9, 9],
    "+86": [11, 11],  "+81": [10, 10],  "+82": [9, 10],   "+852": [8, 8],
    "+61": [9, 9],    "+64": [8, 10],   "+55": [10, 11],  "+52": [10, 10],
    "+54": [10, 10]
  };

  /* Leading digits a MOBILE number can start with, for the markets Blue Salon
     actually sells into. This is what rejects 00000000 and a mistyped
     landline: the length check alone cannot tell a real number from eight
     zeroes. Deliberately GCC-only — mobile ranges are reassigned by regulators
     more often than country code lengths are, and a stale rule here rejects a
     real shopper, which is far worse than letting an odd foreign number
     through. Everywhere else falls back to the length + repeated-digit
     checks. ── */
  var MOBILE_PREFIXES = {
    "+974": ["3", "5", "6", "7"],   // Qatar — 4x is landline
    "+971": ["5"],                  // UAE — 50/52/54/55/56/58
    "+966": ["5"],                  // Saudi Arabia
    "+965": ["5", "6", "9"],        // Kuwait
    "+973": ["3", "6"],             // Bahrain
    "+968": ["7", "9"]              // Oman
  };

  /* Both account-form validators show errors the same way — inline message,
     aria-invalid, red border — so the plumbing lives here once. ── */
  function fieldErrorUI(input, errorEl) {
    return {
      show: function (message) {
        errorEl.textContent = message;
        errorEl.hidden = false;
        input.setAttribute("aria-invalid", "true");
        input.classList.add("has-error");
      },
      clear: function () {
        errorEl.textContent = "";
        errorEl.hidden = true;
        input.removeAttribute("aria-invalid");
        input.classList.remove("has-error");
      }
    };
  }

  function initRegisterPhoneField() {
    var codeInput = document.getElementById("RegisterMobileCode");
    var phoneInput = document.getElementById("RegisterMobile");
    var errorEl = document.getElementById("RegisterMobileError");
    var form = phoneInput && phoneInput.closest("form");
    if (!codeInput || !phoneInput || !errorEl || !form || phoneInput.dataset.phoneValidateInit) return;
    phoneInput.dataset.phoneValidateInit = "true";

    var T = (window.BS_I18N && window.BS_I18N.account) || {};

    function bounds() {
      return PHONE_LENGTHS[codeInput.value] || [4, 15];
    }

    var ui = fieldErrorUI(phoneInput, errorEl);
    var showError = ui.show;
    var clearError = ui.clear;

    // Shoppers habitually type the national trunk prefix — 0501234567 for the
    // UAE, 055 123 4567 for Saudi Arabia. E.164 drops that 0 once a country
    // code is chosen, so strip it, but only when doing so actually produces a
    // number of the right length; otherwise a genuinely wrong entry would be
    // silently reshaped into a different wrong entry.
    function normalize(digits) {
      var range = bounds();
      if (digits.charAt(0) === "0" && digits.length > range[1] &&
          digits.length - 1 >= range[0]) {
        return digits.slice(1);
      }
      return digits;
    }

    // Returns the message to show, or "" when the value is acceptable.
    function problem() {
      var digits = normalize(phoneInput.value.replace(/\D/g, ""));
      if (!digits) {
        return T.phone_required || "Please enter your mobile number.";
      }

      // 00000000 and 66666666 pass every earlier check: eight digits is
      // exactly what Qatar wants. No real mobile number is one digit
      // repeated, so reject the whole class rather than zeroes alone.
      // Written as a scan rather than a backreference regex on purpose:
      // the backreference form is a magnet for escaping bugs: one such bug
      // already hit this very check, replacing its backreference with a
      // literal control character so it silently matched nothing at all.
      if (digits.length > 1 && digits.split("").every(function (d) {
        return d === digits.charAt(0);
      })) {
        return T.phone_invalid ||
          "That doesn’t look like a real mobile number. Please check it.";
      }

      var range = bounds();
      if (digits.length < range[0] || digits.length > range[1]) {
        if (range[0] === range[1]) {
          return (T.phone_length_exact ||
            "Enter the __DIGITS__-digit mobile number for __CODE__.")
            .replace("__DIGITS__", range[0]).replace("__CODE__", codeInput.value);
        }
        return (T.phone_length_range ||
          "Enter a mobile number of __MIN__ to __MAX__ digits for __CODE__.")
          .replace("__MIN__", range[0]).replace("__MAX__", range[1])
          .replace("__CODE__", codeInput.value);
      }

      var prefixes = MOBILE_PREFIXES[codeInput.value];
      if (prefixes && prefixes.indexOf(digits.charAt(0)) === -1) {
        return (T.phone_prefix || "__CODE__ mobile numbers start with __PREFIXES__.")
          .replace("__CODE__", codeInput.value)
          .replace("__PREFIXES__", prefixes.join(", "));
      }

      return "";
    }

    // Strip as they type rather than reject on submit: the shopper never gets
    // to build up a value the form will refuse. Caret is restored by counting
    // the digits before it, so editing mid-number doesn't jump to the end.
    phoneInput.addEventListener("input", function () {
      var before = phoneInput.value.slice(0, phoneInput.selectionStart || 0);
      var digits = phoneInput.value.replace(/\D/g, "");
      if (digits !== phoneInput.value) {
        var caret = before.replace(/\D/g, "").length;
        phoneInput.value = digits;
        try { phoneInput.setSelectionRange(caret, caret); } catch (e) { /* unsupported input type */ }
      }
      // Only ever clear while typing — nagging mid-entry ("too short") before
      // the shopper has finished is noise, so errors appear on blur/submit.
      // Emptying the field clears too: whatever the last message was, it
      // described a value that is no longer there. `required` still catches
      // an empty field at submit.
      if (!errorEl.hidden && (!digits || !problem())) clearError();
    });

    // Write the trunk-prefix strip back into the field rather than only using
    // it to validate: initRegisterPhoneTag reads this input directly, so a
    // number that merely passes as 0501234567 would otherwise be stored with
    // the 0 still on it and dial as a different number.
    function applyNormalize() {
      var digits = phoneInput.value.replace(/\D/g, "");
      var normalized = normalize(digits);
      if (normalized !== phoneInput.value) phoneInput.value = normalized;
    }

    phoneInput.addEventListener("blur", function () {
      if (!phoneInput.value) return; // untouched field isn't an error yet
      applyNormalize();
      var message = problem();
      if (message) showError(message); else clearError();
    });

    // Fired by selectOption in initPhoneCodeCombobox — a number valid for one
    // country is usually the wrong length for the next.
    codeInput.addEventListener("change", function () {
      if (!phoneInput.value) return;
      var message = problem();
      if (message) showError(message); else clearError();
    });

    // Registered before initRegisterPhoneTag's own submit handler (see
    // initAll), so a blocked submit never gets as far as writing the tag.
    form.addEventListener("submit", function (e) {
      applyNormalize();
      var message = problem();
      if (!message) { clearError(); return; }
      e.preventDefault();
      showError(message);
      phoneInput.focus();
    });
  }

  /* ── Register page: email shape check. type="email" alone is far weaker
     than it appears — browsers accept "a@b", "a@b." and "a@-.b" as valid,
     so typos like "name@gmail" or "name@gmail..com" reach the account
     unchallenged, and the welcome mail then bounces with nothing to tell the
     shopper why. This is a deliberately BASIC shape check, not an attempt to
     implement RFC 5322: one @, something before it, a dotted domain, and a
     letters-only TLD of at least two characters. Anything past that belongs
     to the confirmation email, which is the only real proof an address
     works. ── */
  var EMAIL_RE = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~.-]+@[A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?)*\.[A-Za-z]{2,}$/;

  /* Builds an inline error slot underneath a field and wires the field's
     aria-describedby to it. Used for the account fields whose templates do
     not already carry one — the sign-in and password-recovery forms. ── */
  function ensureErrorSlot(input) {
    var described = input.getAttribute("aria-describedby");
    var existing = described && document.getElementById(described);
    if (existing) return existing;

    var slot = document.createElement("p");
    slot.className = "bs-field-error";
    slot.setAttribute("role", "alert");
    slot.hidden = true;
    if (input.id) slot.id = input.id + "Error";
    // .bs-password-field is the eye-toggle wrapper; the slot belongs after
    // the whole field rather than inside it.
    var anchorEl = input.closest(".bs-password-field") || input;
    anchorEl.parentNode.insertBefore(slot, anchorEl.nextSibling);
    if (slot.id) input.setAttribute("aria-describedby", slot.id);
    return slot;
  }

  /* ── Registration: First / Last name.

     Reported: the sign-up form accepted a name made of digits, punctuation
     or a run of spaces, and account creation went through — only the email
     and mobile number were ever checked. Shopify's create_customer form
     has no validation for these either, so this is the only layer there is.

     Deliberately permissive about WHICH letters: the rule is "contains at
     least one letter, in any script" (the Unicode property escape covers
     Arabic, which this storefront serves, alongside Latin), plus the
     punctuation real names carry — apostrophes, hyphens, periods, spaces.
     A name is not a format, and rejecting "O'Brien", "Al-Thani" or
     "أحمد" would be a far worse bug than the one being fixed. What it
     does reject is what was reported: digits, symbol soup, whitespace-only,
     and a single stray character.

     The length cap matches Shopify's own column limit, so a value this
     accepts is one the API will accept too. ── */
  var NAME_MAX = 255;

  function initRegisterNameFields() {
    var T = (window.BS_I18N && window.BS_I18N.account) || {};
    var inputs = document.querySelectorAll(
      '.bs-account-card input[name="customer[first_name]"], .bs-account-card input[name="customer[last_name]"]'
    );

    // Unicode property escapes are ES2018; on anything older this falls back
    // to a Latin+Arabic range, which is every script this storefront renders.
    var hasLetter;
    // An allowlist, not a list of banned symbols: the old blocklist only knew
    // the English keyboard, so Arabic-Indic digits (١٢٣), Arabic punctuation
    // (؟ ، ؛ ٪ « »), currency signs, emoji and full-width characters all got
    // through. A name may hold letters in any script, combining marks (Arabic
    // harakat), spaces, apostrophes, hyphens, periods and the zero-width
    // joiners some names need - nothing else.
    var nameChars = null;
    try {
      hasLetter = new RegExp("\\p{L}", "u");
      nameChars = new RegExp("^[\\p{L}\\p{M} '\u2019.\\-\u200c\u200d]+$", "u");
    } catch (e) {
      hasLetter = /[A-Za-zÀ-ɏ؀-ۿ]/;
    }
    // Fallback for browsers without Unicode property escapes.
    var disallowed = /[0-9\u0660-\u0669\u06f0-\u06f9]|[!@#$%^&*()_+=\[\]{};:"\|<>\/?~`\u060c\u061b\u061f\u066a\u066d\u00ab\u00bb,]/;

    Array.prototype.forEach.call(inputs, function (input) {
      if (input.dataset.nameValidateInit) return;
      input.dataset.nameValidateInit = "true";

      var form = input.closest("form");
      if (!form) return;
      var errorEl = ensureErrorSlot(input);
      var ui = fieldErrorUI(input, errorEl);

      // Also caps the value as typed, so the field cannot silently hold more
      // than the API will store.
      input.setAttribute("maxlength", String(NAME_MAX));

      function problem() {
        var value = input.value;
        if (!value) return "";               // `required` owns the empty case
        var trimmed = value.trim();
        if (!trimmed) {
          return T.name_blank || "Please enter your name.";
        }
        if (trimmed.length < 2) {
          return T.name_short || "Please enter at least 2 characters.";
        }
        if (trimmed.length > NAME_MAX) {
          return (T.name_long || "Please use __MAX__ characters or fewer.")
            .replace("__MAX__", NAME_MAX);
        }
        if ((nameChars ? !nameChars.test(trimmed) : disallowed.test(trimmed)) || !hasLetter.test(trimmed)) {
          return T.name_invalid || "Please use letters only.";
        }
        return "";
      }

      input.addEventListener("blur", function () {
        if (!input.value) return;
        var m = problem();
        if (m) ui.show(m); else ui.clear();
      });

      input.addEventListener("input", function () {
        if (!errorEl.hidden && !problem()) ui.clear();
      });

      form.addEventListener("submit", function (e) {
        var m = problem();
        if (!m) { ui.clear(); return; }
        // Another field may already have claimed focus this submit.
        var alreadyFlagged = form.querySelector(".has-error");
        e.preventDefault();
        ui.show(m);
        if (!alreadyFlagged) input.focus();
      });
    });
  }

  /* Every email field on an account card — register, sign in, and the
     "forgot your password" recovery form. Safe to apply everywhere,
     including sign in: an address that is not a valid address cannot match
     an account either, so checking it here only saves a round trip and can
     never turn away someone who would have got in. ── */
  function initAccountEmailFields() {
    var inputs = document.querySelectorAll('.bs-account-card input[type="email"]');
    Array.prototype.forEach.call(inputs, function (input) {
      if (!input.dataset.emailValidateInit) initAccountEmailField(input);
    });
  }

  function initAccountEmailField(input) {
    var errorEl = ensureErrorSlot(input);
    var form = input.closest("form");
    if (!errorEl || !form) return;
    input.dataset.emailValidateInit = "true";

    var T = (window.BS_I18N && window.BS_I18N.account) || {};
    var ui = fieldErrorUI(input, errorEl);

    function invalid() {
      var value = input.value.trim();
      if (!value) return false; // `required` already covers the empty case
      var local = value.slice(0, value.lastIndexOf("@"));
      // The regex allows dots in the local part but not these placements,
      // which are the ones a fat-fingered address actually produces.
      if (value.indexOf("..") !== -1 || local.charAt(0) === "." ||
          local.charAt(local.length - 1) === ".") return true;
      return !EMAIL_RE.test(value);
    }

    function check() {
      if (invalid()) {
        ui.show(T.email_invalid || "Enter a valid email address, like name@example.com.");
        return false;
      }
      ui.clear();
      return true;
    }

    // Trailing whitespace is the single most common paste artefact, and it is
    // invisible in the field — fix it rather than report it.
    input.addEventListener("blur", function () {
      input.value = input.value.trim();
      if (input.value) check();
    });

    // Same rule as the phone field: never nag mid-entry, only stop nagging.
    input.addEventListener("input", function () {
      if (!errorEl.hidden && !invalid()) ui.clear();
    });

    form.addEventListener("submit", function (e) {
      input.value = input.value.trim();
      if (check()) return;
      e.preventDefault();
      input.focus();
    });
  }

  /* ── Register page: stashes the Mobile number field into the
     create_customer form's customer[tags] as "phone-<digits>" just
     before submit — Shopify's account creation form has no way to set
     customer.phone directly, so the "Extract phone from tags and update
     customer" Shopify Flow does that server-side off this tag instead. ── */
  function initRegisterPhoneTag() {
    var codeInput = document.getElementById("RegisterMobileCode");
    var phoneInput = document.getElementById("RegisterMobile");
    var tagsInput = document.getElementById("RegisterPhoneTag");
    var form = phoneInput && phoneInput.closest("form");
    if (!codeInput || !phoneInput || !tagsInput || !form || form.dataset.phoneTagInit) return;
    form.dataset.phoneTagInit = "true";

    form.addEventListener("submit", function () {
      var digits = phoneInput.value.replace(/\D/g, "");
      tagsInput.value = digits ? "phone-" + codeInput.value + digits : "";
    });
  }

  /* ── Show/hide toggle for every account password field — the sign-in
     popover in the header, plus the register / reset / activate pages.
     Built here rather than in the templates so all five stay in step and
     the markup only has to be a plain <input type="password">: a shopper
     with JS off still gets a working (just masked) field. ── */
  var EYE_OPEN_SVG =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M1.5 12S5.2 5.5 12 5.5 22.5 12 22.5 12 18.8 18.5 12 18.5 1.5 12 1.5 12z"/><circle cx="12" cy="12" r="3.2"/></svg>';
  var EYE_OFF_SVG =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M10.6 6.1A8.6 8.6 0 0 1 12 6c6.8 0 10.5 6 10.5 6a17 17 0 0 1-3.4 3.9M6.2 7.9A17 17 0 0 0 1.5 12S5.2 18 12 18a9.6 9.6 0 0 0 4-.8"/>' +
    '<path d="M9.8 9.9a3.2 3.2 0 0 0 4.4 4.4"/><path d="M3 3l18 18"/></svg>';

  function initPasswordToggles() {
    var T = (window.BS_I18N && window.BS_I18N.account) || {};
    var showLabel = T.show_password || "Show password";
    var hideLabel = T.hide_password || "Hide password";

    document.querySelectorAll(".bs-account-card input[type='password']").forEach(function (input) {
      if (input.dataset.pwToggleInit) return;
      input.dataset.pwToggleInit = "true";

      // Wrap in place so the button can be positioned against the input
      // without the surrounding form layout (label, then field, then next
      // label) noticing anything changed.
      var wrap = document.createElement("div");
      wrap.className = "bs-password-field";
      input.parentNode.insertBefore(wrap, input);
      wrap.appendChild(input);

      var toggle = document.createElement("button");
      toggle.type = "button"; // never submit the form
      toggle.className = "bs-password-toggle";
      toggle.setAttribute("aria-label", showLabel);
      toggle.setAttribute("aria-pressed", "false");
      if (input.id) toggle.setAttribute("aria-controls", input.id);

      // Both icons are built once and then only shown/hidden. Swapping
      // innerHTML on click instead would DETACH the very <svg> the shopper
      // clicked, mid-propagation — and an outside-click handler further up
      // (the header sign-in popover's) then sees a target that is no longer
      // inside itself and dismisses the whole panel. Clicking the eye closed
      // the sign-in form instead of revealing the password.
      var icons = document.createElement("span");
      icons.innerHTML = EYE_OPEN_SVG + EYE_OFF_SVG;
      var eyeOpen = icons.children[0];
      var eyeOff = icons.children[1];
      eyeOff.classList.add("is-hidden");
      toggle.appendChild(eyeOpen);
      toggle.appendChild(eyeOff);
      wrap.appendChild(toggle);

      toggle.addEventListener("click", function () {
        var reveal = input.type === "password";
        input.type = reveal ? "text" : "password";
        eyeOpen.classList.toggle("is-hidden", reveal);
        eyeOff.classList.toggle("is-hidden", !reveal);
        toggle.setAttribute("aria-label", reveal ? hideLabel : showLabel);
        toggle.setAttribute("aria-pressed", reveal ? "true" : "false");
        // Clicking the button moves focus off the field; put it back where
        // the shopper was typing, caret at the end. preventScroll matters in
        // the header sign-in popover: that card scrolls internally, and a
        // default focus() scrolled the field to the top of it — throwing the
        // SIGN IN button and everything under it out of view on every toggle.
        var end = input.value.length;
        try {
          input.focus({ preventScroll: true });
        } catch (e) {
          input.focus();
        }
        try { input.setSelectionRange(end, end); } catch (e) { /* unsupported input type */ }
      });
    });
  }

  /* ── New-password rules for the account forms: register, activate and
     reset. The field previously carried nothing but `required`, so a
     one-character password went all the way to Shopify and came back as a
     server error with the form emptied.

     Scoped by autocomplete="new-password" on purpose. That attribute means
     "a password being created", which is exactly the set of fields a minimum
     length may be applied to. The sign-in forms use current-password and are
     deliberately left alone: an existing customer whose password predates
     this rule must still be able to log in, and a length check on a login
     field would lock them out of their own account.

     PASSWORD_MIN is the theme's own floor. Shopify enforces its own minimum
     server-side and does not publish the number; 8 sits well above it, so the
     browser now rejects everything the server would have, one round trip
     earlier. The server block stays as the authority for what the browser
     cannot know — an email already registered, an expired reset token.

     Raised from 6 to 8 on the account-creation forms only. At 6 the field
     accepted "123456", "password", "qwerty" and "111111" — every one of the
     passwords that leads a credential-stuffing list — which is what QA meant
     by "minimum complexity/length requirements" in bug #23. NIST SP 800-63B
     puts the floor at 8 and tells you to screen against known-breached
     values rather than demand a character-class ritual, so that is the shape
     of the rule below: a real length floor, a small blocklist, and a check
     that the whole thing is not one character repeated. ── */
  var PASSWORD_MIN = 8;

  /* The passwords that actually get tried. Deliberately short and
     deliberately not a complexity rule: forcing an uppercase and a digit
     produces "Password1", which is on every list there is, while a
     passphrase like "correct horse battery" is strong and would fail such a
     rule. Matching is case-insensitive and ignores trailing digits, so
     "Password1" and "qwerty123" are caught by their stems.

     The shop's own name belongs here for the same reason a site called
     Example never wants "example123" protecting an order history. ── */
  var WEAK_PASSWORDS = [
    "password", "passwd", "pass", "123456", "12345678", "123456789",
    "1234567890", "qwerty", "qwertyuiop", "abc123", "111111", "000000",
    "iloveyou", "admin", "welcome", "monkey", "dragon", "letmein",
    "football", "princess", "sunshine", "shadow", "master", "login",
    "starwars", "whatever", "trustno", "bluesalon", "blue salon", "qatar",
    "doha"
  ];

  // "P@ssw0rd" is the password a complexity rule produces, and it is on every
  // breached list there is. Folding the usual substitutions back to letters
  // is what lets the blocklist see it for what it is.
  // No "!" → "i" entry: an exclamation mark is overwhelmingly a suffix
  // ("P@ssw0rd!"), and folding it to a letter turned that into "passwordi",
  // which matches nothing. Left as punctuation it is stripped like any other
  // separator and the stem lands on "password".
  var LEET = { "0": "o", "1": "i", "3": "e", "4": "a", "5": "s", "7": "t", "@": "a", "$": "s" };

  function weakPassword(value) {
    var raw = String(value).toLowerCase();

    // Two stems, both tested. The plain one strips a trailing run of digits,
    // which is the "qwerty123" / "Password2026" shape. The folded one
    // substitutes leet characters first, which is the "P@ssw0rd" shape —
    // kept separate because folding digits to letters would otherwise eat
    // the trailing-digit suffix the plain stem exists to remove.
    var plain = raw.replace(/[^a-z0-9]/g, "");
    var stems = [plain, plain.replace(/[0-9]+$/, "")];

    var folded = "";
    for (var c = 0; c < raw.length; c++) {
      folded += Object.prototype.hasOwnProperty.call(LEET, raw[c]) ? LEET[raw[c]] : raw[c];
    }
    folded = folded.replace(/[^a-z0-9]/g, "");
    stems.push(folded, folded.replace(/[0-9]+$/, ""));

    for (var i = 0; i < WEAK_PASSWORDS.length; i++) {
      var weak = WEAK_PASSWORDS[i].replace(/[^a-z0-9]/g, "");
      for (var j = 0; j < stems.length; j++) {
        if (stems[j] && stems[j] === weak) return true;
      }
    }
    return false;
  }

  // "aaaaaaaa" and "11111111" clear a length floor without being a password
  // at all. Checked on the raw value, not the stem, so "aaaa1111" survives.
  function singleCharacterPassword(value) {
    return value.length > 0 && new RegExp("^(.)\\1*$").test(value);
  }

  /* Four is the lowest count that still lets a short real password through
     while rejecting the two-character patterns. "Pass" has four distinct
     characters and is caught by the length floor instead; "abababab" has
     two and is caught here. Deliberately not higher: a passphrase in a
     language with a small alphabet, or a deliberately repetitive but long
     phrase, is not weak and must not be refused. */
  var PASSWORD_MIN_DISTINCT = 5;

  function distinctCharacters(value) {
    var seen = "";
    for (var i = 0; i < value.length; i++) {
      if (seen.indexOf(value[i]) === -1) seen += value[i];
    }
    return seen.length;
  }

  /* Character classes. Three of the four are required.

     The earlier rules were length + blocklist + variety, which is the NIST
     800-63B shape and lets passphrases through. In practice it also let
     "dfdsfsdfsdffsdf" and "dfghjkldfghjkl" through — a keyboard mash in
     one class, which no shopper would accept as protecting an order
     history, and which QA reported as the validation "not being there".
     Requiring a mix is the rule shoppers expect from an account form, and
     it is the one that makes a mash fail no matter how long it is.

     Three of four, not all four: demanding a symbol as well is the point at
     which people start writing passwords down. Letters are not scoped to
     Latin — \p{Lu}/\p{Ll} cover Arabic-script input too, where available,
     and anything that is not a letter or digit counts as a symbol, so a
     space in a passphrase does. */
  var PASSWORD_MIN_CLASSES = 3;
  var HAS_UPPER, HAS_LOWER;
  try {
    HAS_UPPER = new RegExp("\\p{Lu}", "u");
    HAS_LOWER = new RegExp("\\p{Ll}", "u");
  } catch (e) {
    HAS_UPPER = /[A-Z]/;
    HAS_LOWER = /[a-z]/;
  }

  function characterClasses(value) {
    var n = 0;
    if (HAS_LOWER.test(value)) n++;
    if (HAS_UPPER.test(value)) n++;
    if (/[0-9]/.test(value)) n++;
    if (/[^A-Za-z0-9À-ɏ؀-ۿ]/.test(value)) n++;
    return n;
  }

  /* A run of four or more consecutive characters along the alphabet, the
     digits or a keyboard row, in either direction: "abcd", "4321", "qwer",
     "lkjh". "Abcd1234!" clears three classes and five distinct characters
     while being two sequences and a punctuation mark — this is what stops
     the class rule from being satisfied by the most predictable thing that
     satisfies it. */
  var SEQUENCES = [
    "abcdefghijklmnopqrstuvwxyz",
    "0123456789",
    "qwertyuiop",
    "asdfghjkl",
    "zxcvbnm",
    "1qaz2wsx3edc"
  ];
  var SEQUENCE_RUN = 4;

  function hasSequence(value) {
    var v = String(value).toLowerCase();
    for (var s = 0; s < SEQUENCES.length; s++) {
      var fwd = SEQUENCES[s];
      var rev = fwd.split("").reverse().join("");
      for (var i = 0; i + SEQUENCE_RUN <= fwd.length; i++) {
        if (v.indexOf(fwd.substr(i, SEQUENCE_RUN)) !== -1) return true;
        if (v.indexOf(rev.substr(i, SEQUENCE_RUN)) !== -1) return true;
      }
    }
    return false;
  }

  /* Deliberately NOT PASSWORD_MIN. This one guards the SIGN IN forms, where
     the job is only to skip a pointless round trip for a password that could
     never have been set in the first place — never to enforce today's policy
     on an account created under an older one. Raising this to PASSWORD_MIN
     would lock out every existing customer whose password is exactly 5
     characters, permanently and silently: they would have no way back in
     except a password reset.

     Shopify does not publish its own server-side minimum, and it is not in
     the docs; 5 is its long-standing floor, so nothing shorter can belong to
     a real account. If that ever turns out to be wrong the fix is to set
     this to 1, which disables the check without touching anything else. ── */
  var SIGN_IN_PASSWORD_MIN = 5;

  /* ── Where a successful sign-in lands (bug #27).

     Shopify sends every classic-accounts login to /account unless the form
     carries a return_to. The templates ship routes.root_url in that field so
     the no-JavaScript answer is the home page rather than the account page;
     this upgrades it to the page the shopper was actually on, which is the
     "preceding page / shopping funnel" half of what was asked for.

     Two sources, because the two forms are reached differently:
       - the header popover is opened ON the page being shopped, so the
         current URL is the right destination,
       - /account/login is arrived AT, so the referrer is.

     Everything is forced back to a same-origin path before it is used. A
     return_to is a redirect target handed to the server inside a form the
     page controls, so an absolute URL from document.referrer is exactly the
     shape an open-redirect takes; rebuilding it as pathname + search means
     only a path on this storefront can ever be submitted. Account pages are
     skipped so signing in from /account/login does not send you back to
     /account/login. ── */
  function initLoginReturnTo() {
    var fields = document.querySelectorAll("input[data-return-to]");
    if (!fields.length) return;

    // Same-origin path, or "" — never a host, scheme or protocol-relative
    // "//evil.example" (which new URL() would resolve to another origin).
    function samePath(href) {
      if (!href) return "";
      var url;
      try {
        url = new URL(href, window.location.href);
      } catch (e) {
        return "";
      }
      if (url.origin !== window.location.origin) return "";
      var path = url.pathname + url.search;
      // /account, /account/login, /account/register, /challenge — none of
      // them are a place to be returned to after signing in.
      if (/^\/([a-z]{2}(-[a-z]{2})?\/)?(account|challenge)(\/|$)/i.test(url.pathname)) return "";
      return path;
    }

    var onLoginPage = /\/account\/(login|register)/.test(window.location.pathname);
    var target = onLoginPage
      ? samePath(document.referrer)
      : samePath(window.location.href);

    if (!target) return; // leave the template's routes.root_url in place

    Array.prototype.forEach.call(fields, function (field) {
      field.value = target;
    });

    /* return_to is not enough on its own. Shopify injects its Shop sign-in
       modules (loader.init-customer-accounts*.esm.js) into these pages and
       adds login_with_shop[...] fields to the form at runtime; when a
       sign-in goes down that path Shopify's own redirect wins and the
       form's return_to is ignored — which is why the field is present and
       correct on all three forms and the shopper still lands on /account.

       So the destination is also parked in sessionStorage on submit and
       claimed back on /account, which works whichever mechanism actually
       handled the sign-in. Deliberately NOT set when `target` is empty:
       that is the case where the shopper was on an account page to begin
       with (they clicked "My Account" while signed out), and sending them
       anywhere other than /account would be wrong. */
    var seen = [];
    Array.prototype.forEach.call(fields, function (field) {
      var form = field.form;
      if (!form || seen.indexOf(form) !== -1) return;
      seen.push(form);
      form.addEventListener("submit", function () {
        try { sessionStorage.setItem(POST_LOGIN_KEY, target); } catch (e) {}
      });
    });
  }

  var POST_LOGIN_KEY = "bs_post_login_return";

  /* Claims the destination parked by initLoginReturnTo. Runs only on
     /account itself, and only once — the key is removed before the redirect
     so a later visit to the account page stays put. */
  function initPostLoginRedirect() {
    if (!/^\/([a-z]{2}(-[a-z]{2})?\/)?account\/?$/i.test(window.location.pathname)) return;

    var dest = null;
    try {
      dest = sessionStorage.getItem(POST_LOGIN_KEY);
      sessionStorage.removeItem(POST_LOGIN_KEY);
    } catch (e) {
      return;
    }
    if (!dest) return;

    // Re-checked rather than trusted. This page wrote the value, but it has
    // been through storage since, and a redirect target is the one thing
    // worth validating twice: a path on this origin, never an account page.
    if (dest.charAt(0) !== "/" || dest.charAt(1) === "/") return;
    if (/^\/([a-z]{2}(-[a-z]{2})?\/)?(account|challenge)(\/|$)/i.test(dest)) return;

    // replace, not assign: Back from the destination should reach the page
    // the shopper signed in from, not bounce through /account again.
    window.location.replace(dest);
  }

  function initNewPasswordFields() {
    var T = (window.BS_I18N && window.BS_I18N.account) || {};
    var fields = document.querySelectorAll('.bs-account-card input[autocomplete="new-password"]');
    if (!fields.length) return;

    // Pair each "new password" with its confirmation, where the form has one
    // (activate + reset do, register does not).
    var primaries = [];
    Array.prototype.forEach.call(fields, function (input) {
      if ((input.name || "").indexOf("password_confirmation") === -1) primaries.push(input);
    });

    primaries.forEach(function (input) {
      if (input.dataset.pwRulesInit) return;
      input.dataset.pwRulesInit = "true";

      var form = input.closest("form");
      if (!form) return;
      var confirm = form.querySelector('input[name="customer[password_confirmation]"]');

      // The error and hint slots are built here rather than in the three
      // templates so all of them stay in step and none can drift.
      function slotAfter(el, className, text) {
        var p = document.createElement("p");
        p.className = className;
        if (text) p.textContent = text;
        // .bs-password-field is the eye-toggle wrapper (added before this
        // runs) — the slot belongs after the whole field, not inside it.
        var anchorEl = el.closest(".bs-password-field") || el;
        anchorEl.parentNode.insertBefore(p, anchorEl.nextSibling);
        return p;
      }

      // Shopify's own guidance: state the requirement before the shopper
      // starts typing, not after their first attempt is rejected.
      slotAfter(input, "bs-field-hint",
        (T.password_hint || "At least __MIN__ characters.").replace("__MIN__", PASSWORD_MIN));

      var errorEl = slotAfter(input, "bs-field-error");
      errorEl.setAttribute("role", "alert");
      errorEl.hidden = true;
      var ui = fieldErrorUI(input, errorEl);

      var confirmError = null, confirmUi = null;
      if (confirm) {
        confirmError = slotAfter(confirm, "bs-field-error");
        confirmError.setAttribute("role", "alert");
        confirmError.hidden = true;
        confirmUi = fieldErrorUI(confirm, confirmError);
      }

      // Never trimmed, and paste is never blocked: leading or trailing
      // spaces are legitimate characters in a password, and password
      // managers rely on paste.
      function problem() {
        var value = input.value;
        if (!value) return "";  // `required` owns the empty case
        if (!value.trim()) {
          return T.password_blank || "Your password can’t be only spaces.";
        }
        if (value.length < PASSWORD_MIN) {
          return (T.password_short || "Use at least __MIN__ characters.")
            .replace("__MIN__", PASSWORD_MIN);
        }
        // Length last-but-one: a shopper who typed "pass" should be told it
        // is short, not that it is common, because lengthening it is the
        // step they are already on.
        if (singleCharacterPassword(value)) {
          return T.password_repeated ||
            "Use more than one repeated character.";
        }
        // All digits. "657567567" clears eight characters, is on no
        // blocklist and repeats no single character, yet it is a phone
        // number, a date or an ID — the shapes people actually reach for
        // when a form asks for digits. A ten-digit numeric password has
        // roughly the strength of a six-character mixed one, so length
        // alone cannot carry it.
        if (/^[0-9]+$/.test(value)) {
          return T.password_numeric ||
            "Add letters as well — numbers alone are too easy to guess.";
        }
        // Ahead of variety and the blocklist: "dfghjkldfghjkl" has eight
        // distinct characters and is on no list, so this is the rule that
        // actually catches a one-class mash, and the message tells the
        // shopper exactly what to add.
        if (characterClasses(value) < PASSWORD_MIN_CLASSES) {
          return T.password_classes ||
            "Use at least 3 of these: lowercase letters, uppercase letters, numbers, symbols.";
        }
        if (hasSequence(value)) {
          return T.password_sequence ||
            "Avoid sequences like “abcd”, “1234” or “qwer”.";
        }
        // "abababab" and "aaaabbbb" pass every rule above while being two
        // characters wearing a disguise. Counting distinct characters is a
        // cheap stand-in for entropy and catches the whole family at once.
        if (distinctCharacters(value) < PASSWORD_MIN_DISTINCT) {
          return T.password_variety ||
            "Please mix in a few more different characters.";
        }
        if (weakPassword(value)) {
          return T.password_common ||
            "That password is too common. Please choose another.";
        }
        return "";
      }

      function mismatch() {
        if (!confirm || !confirm.value || !input.value) return "";
        return confirm.value === input.value
          ? "" : (T.password_mismatch || "Both passwords must match.");
      }

      /* Nothing is said until the shopper leaves the field once — telling
         someone their password is too short while they are on the third
         character is noise, not help. After that first blur the message
         tracks every keystroke, so a rejected password visibly becomes an
         accepted one as they fix it rather than staying red until they tab
         away again. That gap is why a password could look unchallenged:
         the rule had fired, but only on blur, and the field was still
         focused. */
      var touched = false;
      input.addEventListener("blur", function () {
        if (!input.value) return;
        touched = true;
        var m = problem();
        if (m) ui.show(m); else ui.clear();
      });
      input.addEventListener("input", function () {
        if (!touched) return;
        var m = problem();
        if (m) ui.show(m); else ui.clear();
      });

      if (confirm) {
        confirm.addEventListener("blur", function () { var m = mismatch(); if (m) confirmUi.show(m); else confirmUi.clear(); });
        confirm.addEventListener("input", function () { if (!confirmError.hidden && !mismatch()) confirmUi.clear(); });
      }

      form.addEventListener("submit", function (e) {
        var m = problem();
        var cm = mismatch();
        if (!m) ui.clear();
        if (!cm && confirmUi) confirmUi.clear();
        if (!m && !cm) return;
        // Another field earlier in the form may already have claimed focus
        // this submit (mobile number, email); don't yank it down here.
        var alreadyFlagged = form.querySelector(".has-error");
        e.preventDefault();
        if (m) ui.show(m);
        if (cm && confirmUi) confirmUi.show(cm);
        if (!alreadyFlagged) (m ? input : confirm).focus();
      });
    });
  }

  /* ── Sign-in forms: stop the obviously-impossible submit. Typing three
     characters and pressing SIGN IN used to cost a full page reload to be
     told the credentials were wrong. Scoped by autocomplete="current-password"
     so it can only ever touch sign-in fields.

     The email half of these forms is handled by initAccountEmailFields.
     Everything the browser cannot know — whether the password is actually
     the right one, whether the account exists — stays with the server, which
     is still the only authority on whether a sign-in succeeds. ── */
  function initSignInPasswordFields() {
    var T = (window.BS_I18N && window.BS_I18N.account) || {};
    var inputs = document.querySelectorAll('.bs-account-card input[autocomplete="current-password"]');

    Array.prototype.forEach.call(inputs, function (input) {
      if (input.dataset.signInPwInit) return;
      input.dataset.signInPwInit = "true";

      var form = input.closest("form");
      if (!form) return;
      var errorEl = ensureErrorSlot(input);
      var ui = fieldErrorUI(input, errorEl);

      // No hint rendered here, unlike the new-password fields: this is not a
      // rule the shopper gets to satisfy by choosing differently, it is just
      // a floor below which the value cannot be their password.
      function problem() {
        if (!input.value) return "";  // `required` owns the empty case
        if (input.value.length < SIGN_IN_PASSWORD_MIN) {
          return (T.password_short || "Use at least __MIN__ characters.")
            .replace("__MIN__", SIGN_IN_PASSWORD_MIN);
        }
        return "";
      }

      input.addEventListener("input", function () {
        if (!errorEl.hidden && !problem()) ui.clear();
      });

      form.addEventListener("submit", function (e) {
        var m = problem();
        if (!m) { ui.clear(); return; }
        var alreadyFlagged = form.querySelector(".has-error");
        e.preventDefault();
        ui.show(m);
        if (!alreadyFlagged) input.focus();
      });
    });
  }

  /* ── Flag pickers on the address form ─────────────────────
     The register page has two controls the address form did not: a
     Country/region list with flags, and a phone field whose dial code is
     picked from that same list. Both are built here from one factory, and
     both reuse the register control's markup classes (.bs-phone-code-*)
     wholesale — flags, search box, bottom-sheet behaviour on phones — so
     the theme carries one flag control rather than three.

     Neither picker owns any data. The country list is built from the
     native <select>'s own options, so Shopify's all_country_option_tags
     stays the source of truth (including the data-provinces payload the
     province dropdown reads); the dial codes come from the shared
     bs-country-flags.js list. ── */

  var PICKER_CHEV = '<svg class="bs-phone-code-chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>';
  var PICKER_MAG = '<svg class="bs-phone-code-searchicon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>';

  /* opts: { items, className, searchLabel, emptyText, rowMeta, onChoose }
     Each item is { value, label, iso }. Returns { wrap, select(value) }. */
  function createFlagPicker(opts) {
    var flags = window.BSCountryFlags;
    var current = null;

    var wrap = document.createElement("div");
    wrap.className = "bs-phone-code " + opts.className;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "bs-phone-code-btn";
    btn.setAttribute("aria-haspopup", "listbox");
    btn.setAttribute("aria-expanded", "false");
    btn.innerHTML =
      '<img class="bs-phone-code-flag bs-phone-code-btn-flag" width="20" height="15" alt="" decoding="async">' +
      '<span class="bs-phone-code-abbr" aria-hidden="true"></span>' +
      '<span class="bs-phone-code-dial"></span>' +
      PICKER_CHEV;
    wrap.appendChild(btn);

    var panel = document.createElement("div");
    panel.className = "bs-phone-code-panel";
    panel.hidden = true;
    panel.innerHTML =
      '<div class="bs-phone-code-searchwrap">' + PICKER_MAG +
      '<input type="text" class="bs-phone-code-search" autocomplete="off">' +
      "</div>" +
      '<ul class="bs-phone-code-list" role="listbox"></ul>' +
      '<p class="bs-phone-code-empty" hidden></p>';
    wrap.appendChild(panel);

    var search = panel.querySelector(".bs-phone-code-search");
    var list = panel.querySelector(".bs-phone-code-list");
    var empty = panel.querySelector(".bs-phone-code-empty");
    var btnFlag = btn.querySelector(".bs-phone-code-btn-flag");
    var btnAbbr = btn.querySelector(".bs-phone-code-abbr");
    var btnText = btn.querySelector(".bs-phone-code-dial");

    if (opts.searchLabel) {
      search.placeholder = opts.searchLabel;
      search.setAttribute("aria-label", opts.searchLabel);
      btn.setAttribute("aria-label", opts.searchLabel);
    }
    empty.textContent = opts.emptyText || "";

    var rows = opts.items.map(function (item) {
      var li = document.createElement("li");
      li.className = "bs-phone-code-option";
      li.setAttribute("role", "option");
      li.setAttribute("aria-selected", "false");
      li.tabIndex = -1;
      li.dataset.value = item.value;
      li.dataset.search = (item.label + " " + (opts.rowMeta ? opts.rowMeta(item) : "")).toLowerCase();
      li.innerHTML =
        flagMarkup(item, "bs-phone-code-flag", true) +
        '<span class="bs-phone-code-option-name"></span>' +
        (opts.rowMeta ? '<span class="bs-phone-code-option-dial"></span>' : "");
      li.querySelector(".bs-phone-code-option-name").textContent = item.label;
      if (opts.rowMeta) li.querySelector(".bs-phone-code-option-dial").textContent = opts.rowMeta(item);
      li.__item = item;
      list.appendChild(li);
      return li;
    });

    function flagMarkup(item, cls, lazy) {
      if (!item.iso) {
        return '<span class="' + cls + ' bs-phone-code-flag-fallback" aria-hidden="true">' +
          escapeHtml(item.label.slice(0, 2).toUpperCase()) + "</span>";
      }
      return '<img class="' + cls + '" src="' + flags.src(item.iso, 40) + '" srcset="' + flags.src(item.iso, 80) +
        ' 2x" width="20" height="15" alt=""' + (lazy ? ' loading="lazy"' : "") +
        ' decoding="async" data-iso="' + item.iso.toUpperCase() + '">';
    }

    function escapeHtml(text) {
      var box = document.createElement("span");
      box.textContent = text;
      return box.innerHTML;
    }

    // A flag that fails to load is replaced by its ISO letters rather than
    // leaving a broken image. Capture phase, because error does not bubble.
    list.addEventListener("error", function (e) {
      var img = e.target;
      if (!img.classList || !img.classList.contains("bs-phone-code-flag")) return;
      var stand = document.createElement("span");
      stand.className = "bs-phone-code-flag bs-phone-code-flag-fallback";
      stand.textContent = img.dataset.iso || "";
      stand.setAttribute("aria-hidden", "true");
      img.replaceWith(stand);
    }, true);

    btnFlag.addEventListener("error", function () { btn.classList.add("is-flagless"); });

    function select(value) {
      var row = rows.filter(function (li) { return li.dataset.value === String(value); })[0];
      current = row ? row.__item : null;
      rows.forEach(function (li) {
        var on = li === row;
        li.classList.toggle("is-selected", on);
        li.setAttribute("aria-selected", String(on));
      });
      if (!current) return;
      btnText.textContent = opts.buttonText ? opts.buttonText(current) : current.label;
      btnAbbr.textContent = (current.iso || current.label.slice(0, 2)).toUpperCase();
      if (current.iso) {
        btn.classList.remove("is-flagless");
        btnFlag.src = flags.src(current.iso, 40);
        btnFlag.srcset = flags.src(current.iso, 80) + " 2x";
      } else {
        btn.classList.add("is-flagless");
        btnFlag.removeAttribute("src");
        btnFlag.removeAttribute("srcset");
      }
    }

    function visible() {
      return rows.filter(function (li) { return !li.hidden; });
    }

    function filter() {
      var q = search.value.trim().toLowerCase();
      var shown = 0;
      rows.forEach(function (li) {
        var hit = !q || li.dataset.search.indexOf(q) !== -1;
        li.hidden = !hit;
        if (hit) shown++;
      });
      empty.hidden = shown > 0;
    }

    /* Four rows, the search box and the panel's own padding. Below this the
       list stops being a list — you get one country and a scrollbar, which
       is what the field looked like when it sat near the bottom of the
       window. */
    var ROW_H = 38;
    var MIN_LIST = ROW_H * 4;
    var CHROME = 62; // search box + panel padding
    var GAP = 6;

    /* Decide which side of the button the panel hangs off, and how tall its
       list may be. Desktop only: under 640px the panel is a bottom sheet
       pinned to the viewport (see the CSS), where neither is ours to set. */
    function place() {
      if (window.matchMedia("(max-width: 640px)").matches) {
        panel.classList.remove("is-above");
        list.style.maxHeight = "";
        return;
      }

      var box = btn.getBoundingClientRect();
      var below = window.innerHeight - box.bottom - GAP - 8;
      var above = box.top - GAP - 8;
      var wantAbove = below < MIN_LIST + CHROME && above > below;

      panel.classList.toggle("is-above", wantAbove);
      var room = (wantAbove ? above : below) - CHROME;

      // Still not enough either way — scroll the field towards the middle of
      // the window rather than open a two-row list against its edge. The
      // scroll listener below runs place() again once that lands.
      if (room < MIN_LIST) btn.scrollIntoView({ block: "center", behavior: "smooth" });

      // Never taller than the room actually there: a panel that overflows
      // the window is worse than a shorter list, because the rows past the
      // edge cannot be reached at all.
      list.style.maxHeight = Math.max(ROW_H, Math.min(264, room)) + "px";
    }

    // The window can move under an open panel — the page scrolls, the
    // address card expands, the phone keyboard resizes the viewport — so
    // the placement is re-run rather than decided once on open.
    function watch(on) {
      var how = on ? "addEventListener" : "removeEventListener";
      window[how]("scroll", place, true);
      window[how]("resize", place);
    }

    function open() {
      panel.hidden = false;
      btn.setAttribute("aria-expanded", "true");
      search.value = "";
      filter();
      place();
      watch(true);
      search.focus();
      var on = rows.filter(function (li) { return li.classList.contains("is-selected"); })[0];
      if (on) on.scrollIntoView({ block: "nearest" });
    }

    function close(refocus) {
      if (panel.hidden) return;
      panel.hidden = true;
      panel.classList.remove("is-above");
      watch(false);
      btn.setAttribute("aria-expanded", "false");
      if (refocus) btn.focus();
    }

    function choose(li) {
      select(li.dataset.value);
      close(true);
      if (opts.onChoose) opts.onChoose(li.__item);
    }

    btn.addEventListener("click", function () { if (panel.hidden) open(); else close(true); });
    btn.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); }
    });
    list.addEventListener("click", function (e) {
      var li = e.target.closest(".bs-phone-code-option");
      if (li) choose(li);
    });
    search.addEventListener("input", filter);

    panel.addEventListener("keydown", function (e) {
      var items = visible();
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        if (!items.length) return;
        var at = items.indexOf(document.activeElement);
        var step = e.key === "ArrowDown" ? 1 : -1;
        var next = items[Math.max(0, Math.min(items.length - 1, at < 0 ? 0 : at + step))];
        if (next) next.focus();
      } else if (e.key === "Enter") {
        var li = e.target.closest(".bs-phone-code-option") || items[0];
        if (li) { e.preventDefault(); choose(li); }
      } else if (e.key === "Escape") {
        e.preventDefault();
        close(true);
      }
    });

    document.addEventListener("click", function (e) {
      if (!wrap.contains(e.target)) close(false);
    });

    return { wrap: wrap, select: select };
  }

  function initCountryFlagSelects() {
    if (!window.BSCountryFlags) return;
    document.querySelectorAll("select[data-address-country]").forEach(initCountryFlagSelect);
    document.querySelectorAll("input[data-address-phone]").forEach(initAddressPhoneField);
  }

  /* Exposed so a country or phone field added after boot — a re-rendered
     address form, or a template that injects one — can be enhanced too. */
  BS.initCountryFlagSelects = initCountryFlagSelects;

  function initCountryFlagSelect(select) {
    if (select.dataset.flagPicker) return;
    select.dataset.flagPicker = "true";
    var flags = window.BSCountryFlags;

    /* all_country_option_tags emits the shop's popular countries, then a
       literal "---------" option as a separator, then the full list. A
       native select renders that as an unpickable-looking rule; a custom
       list renders it as a country called "---" with no flag, which is
       exactly what it looked like. Drop it, and anything else with no real
       value, rather than offering it as a choice. */
    var items = [];
    Array.prototype.forEach.call(select.options, function (opt) {
      var label = opt.textContent.trim();
      if (!opt.value || opt.disabled || /^-+$/.test(label)) return;
      // The label is translated (Arabic "قطر"), the flag table is English;
      // the option's value is tried when the label finds nothing.
      items.push({ value: opt.value, label: label, iso: flags.iso(label) || flags.iso(opt.value) });
    });

    var picker = createFlagPicker({
      items: items,
      className: "bs-country-select",
      searchLabel: select.dataset.searchLabel || "",
      emptyText: select.dataset.emptyText || "",
      onChoose: function (item) {
        select.value = item.value;
        // The province dropdown is driven by the native select, not by this
        // control — so tell it.
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });

    select.parentNode.insertBefore(picker.wrap, select);
    picker.wrap.appendChild(select);
    select.classList.add("bs-country-select-native");
    select.setAttribute("tabindex", "-1");
    // Something else may set the country — the addresses template restores
    // the saved one on load — so follow the select rather than assume.
    select.addEventListener("change", function () { picker.select(select.value); });
    picker.select(select.value);
  }

  /* ── Address phone field ──
     Was a single tel input, so the dial code was whatever the shopper
     happened to type — or missing. It becomes the register page's control:
     a country picker holding the code, and a digits-only box for the rest.

     The posted field keeps its name and its value (code + number, exactly
     the shape already stored); it turns into a hidden input and hands its
     `required` to the visible box, since a hidden control cannot be focused
     to report a validation message against. ── */
  function initAddressPhoneField(input) {
    if (input.dataset.flagPicker) return;
    input.dataset.flagPicker = "true";
    var flags = window.BSCountryFlags;

    var items = flags.countries().map(function (c) {
      return { value: c.d + "|" + c.i, label: c.n, iso: c.i, dial: c.d };
    });

    var field = document.createElement("div");
    field.className = "bs-phone-field";
    input.parentNode.insertBefore(field, input);

    var number = document.createElement("input");
    number.type = "tel";
    number.className = "bs-phone-number";
    number.inputMode = "numeric";
    number.autocomplete = "tel-national";
    number.maxLength = 15;
    if (input.id) number.id = input.id + "Local";
    if (input.required) {
      number.required = true;
      number.setAttribute("aria-required", "true");
    }
    var label = input.id && document.querySelector('label[for="' + input.id + '"]');
    if (label && number.id) label.setAttribute("for", number.id);

    // Split whatever is stored. A number saved before this control existed
    // carries no recognised code; it keeps the default country and the
    // digits stay in the box rather than being silently reinterpreted.
    var parsed = flags.splitDial(input.value);
    var startValue = parsed ? parsed.country.d + "|" + parsed.country.i : items[0].value;
    number.value = parsed ? parsed.number : String(input.value || "").replace(/\D/g, "");

    var picker = createFlagPicker({
      items: items,
      className: "bs-phone-code",
      searchLabel: input.dataset.searchLabel || "",
      emptyText: input.dataset.emptyText || "",
      buttonText: function (item) { return item.dial; },
      rowMeta: function (item) { return item.dial; },
      onChoose: sync
    });

    field.appendChild(picker.wrap);
    field.appendChild(number);
    picker.select(startValue);

    // The posted field steps out of the layout but keeps its name and value.
    input.type = "hidden";
    input.required = false;
    input.removeAttribute("required");
    input.removeAttribute("aria-required");
    input.removeAttribute("pattern");
    field.appendChild(input);

    function sync() {
      var dial = picker.wrap.querySelector(".bs-phone-code-option.is-selected");
      dial = dial ? dial.__item.dial : items[0].dial;
      number.value = number.value.replace(/\D/g, "");
      input.value = number.value ? dial + number.value : "";
    }

    number.addEventListener("input", sync);
    number.addEventListener("blur", sync);
    // Last word before the form serialises, in case nothing fired.
    var form = input.closest("form");
    if (form) form.addEventListener("submit", sync, true);
    sync();
  }


  /* ── Language switcher ──────────────────────────────────────
     Markup: snippets/language-switcher.liquid, in the desktop header and the
     mobile drawer. Liquid writes each option's href by swapping the locale
     prefix on request.path; that cannot see a translated handle or the query
     string, so here every href is re-resolved from the page itself:

       1. The page's own <link rel="alternate" hreflang> for that language.
          Shopify writes these with the translated handle, so /products/x in
          English can map to a differently-named Arabic product URL. They
          describe the document as it was served, so they are only trusted
          while location.pathname is still the path that was loaded.
       2. Otherwise, the current path with its locale prefix swapped.

     The live query string and hash always replace the alternate's own query:
     filters, sort, pagination and ?variant= are pushed into the URL after
     load, and the alternate only knows what the server saw.

     Shopify writes alternates on the primary domain. On a host that is not
     the canonical one (theme preview, the dev server, the .myshopify domain)
     an alternate on the canonical domain is re-based onto the current
     origin, so switching language never jumps the shopper to another site.
     An alternate on some third domain (a per-language market domain) is
     followed as-is. */
  function initLanguageSwitcher() {
    var switches = document.querySelectorAll("[data-lang-switch]");
    if (!switches.length) return;

    var loadedPath = location.pathname;
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var canonicalOrigin = null;
    var canonical = document.querySelector('link[rel="canonical"]');
    try { if (canonical) canonicalOrigin = new URL(canonical.href).origin; } catch (e) {}
    var country = String((window.Shopify && window.Shopify.country) || "").toLowerCase();

    function trimRoot(root) {
      root = String(root || "/");
      return root === "/" ? "" : root.replace(/\/+$/, "");
    }

    // hreflang matches by language; with Markets the tag carries a region
    // ("ar-QA"), so prefer the shopper's own country, then any region.
    function alternateFor(code) {
      var want = String(code).toLowerCase();
      var base = want.split("-")[0];
      var exact = null, local = null, regional = null;
      document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(function (link) {
        var tag = String(link.getAttribute("hreflang") || "").toLowerCase();
        if (tag === want) exact = exact || link;
        else if (country && tag === base + "-" + country) local = local || link;
        else if (tag.split("-")[0] === base) regional = regional || link;
      });
      var hit = exact || local || regional;
      return hit ? hit.href : null;
    }

    function prefixSwap(sw, option) {
      // The header toggle carries no option for the current language, so the
      // current root comes from the switch itself.
      var fromRoot = trimRoot(sw.getAttribute("data-lang-current-root"));
      var toRoot = trimRoot(option.getAttribute("data-lang-root"));
      var rest = location.pathname;
      if (fromRoot && (rest === fromRoot || rest.indexOf(fromRoot + "/") === 0)) {
        rest = rest.slice(fromRoot.length) || "/";
      }
      return rest === "/" ? (toRoot || "/") : toRoot + rest;
    }

    function targetUrl(sw, option) {
      var url = null;
      if (location.pathname === loadedPath) {
        var alt = alternateFor(option.getAttribute("data-lang-option"));
        if (alt) {
          try {
            url = new URL(alt, location.href);
            if (url.origin !== location.origin && url.origin === canonicalOrigin) {
              url = new URL(url.pathname, location.origin);
            }
          } catch (e) { url = null; }
        }
      }
      if (!url) url = new URL(prefixSwap(sw, option), location.origin);
      url.search = location.search;
      url.hash = location.hash;
      return url.origin === location.origin ? url.pathname + url.search + url.hash : url.href;
    }

    function refresh(sw) {
      sw.querySelectorAll(".bs-lang-option").forEach(function (option) {
        option.setAttribute("href", targetUrl(sw, option));
      });
    }

    // The thumb is one shared pill that slides between options. offsetLeft is
    // physical in both reading directions, and so is the thumb's left: 0, so
    // the same arithmetic holds in Arabic.
    function placeThumb(sw, option) {
      var thumb = sw.querySelector(".bs-lang-thumb");
      if (!thumb || !option || !option.offsetWidth) return;
      thumb.style.width = option.offsetWidth + "px";
      thumb.style.transform = "translateX(" + option.offsetLeft + "px)";
    }

    function current(sw) {
      return sw.querySelector(".bs-lang-option.is-current");
    }

    function select(sw, option) {
      sw.querySelectorAll(".bs-lang-option").forEach(function (o) {
        var on = o === option;
        o.classList.toggle("is-current", on);
        if (on) o.setAttribute("aria-current", "true");
        else o.removeAttribute("aria-current");
      });
      placeThumb(sw, option);
    }

    switches.forEach(function (sw) {
      var initial = current(sw);

      // Park the thumb under the active option with no transition, then let
      // later moves animate.
      sw.classList.add("is-static");
      placeThumb(sw, initial);
      sw.classList.add("is-enhanced");
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { sw.classList.remove("is-static"); });
      });

      // The drawer copy is hidden (zero width) until the drawer opens, and the
      // web fonts can land after this runs: re-measure whenever it resizes.
      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          sw.classList.add("is-static");
          placeThumb(sw, current(sw));
          requestAnimationFrame(function () { sw.classList.remove("is-static"); });
        }).observe(sw);
      }

      refresh(sw);
      // Re-resolve just before use too: the query string may have changed
      // since load, and a hover/long-press shows (or opens) the href as-is.
      ["pointerenter", "focusin", "touchstart"].forEach(function (type) {
        sw.addEventListener(type, function () { refresh(sw); }, { passive: true });
      });

      sw.addEventListener("click", function (e) {
        var option = e.target.closest("[data-lang-option]");
        if (!option || !sw.contains(option)) return;
        if (option.classList.contains("is-current")) {
          e.preventDefault();
          return;
        }
        var url = targetUrl(sw, option);
        option.setAttribute("href", url);
        // New tab / window / download: let the browser have the fresh href.
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        if (sw.getAttribute("aria-busy") === "true") return;
        sw.setAttribute("aria-busy", "true");
        // The drawer's thumb slides to the chosen language; the header toggle
        // has no thumb and simply holds its busy state.
        if (sw.querySelector(".bs-lang-thumb")) select(sw, option);
        // Two frames so the slide has started before the browser begins
        // tearing the page down for the next one.
        if (reduceMotion) { location.assign(url); return; }
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { location.assign(url); });
        });
      });

      // Back/forward cache: the restored page still shows the language that
      // was picked on the way out. Put it back to the page's own language.
      window.addEventListener("pageshow", function (e) {
        if (!e.persisted) return;
        sw.removeAttribute("aria-busy");
        sw.classList.add("is-static");
        select(sw, initial);
        refresh(sw);
        requestAnimationFrame(function () { sw.classList.remove("is-static"); });
      });
    });
  }


  /* ── Header description collapse ────────────────────────────
     Markup: snippets/header-intro.liquid. The chevron is only revealed when
     the copy really runs past its one line: wider than its box (the closed
     copy is nowrap) or taller (authored markup can hold several paragraphs).
     Re-checked on resize while closed, since a wider screen can make it fit.
     The control is icon-only, so its accessible name is swapped here, from
     the two translated labels Liquid wrote onto it. */
  function initHeaderIntros(scope) {
    (scope || document).querySelectorAll("[data-bs-intro]").forEach(function (intro) {
      if (intro.dataset.bsIntroReady) return;
      intro.dataset.bsIntroReady = "true";
      var copy = intro.querySelector(".bs-intro-copy");
      var toggle = intro.querySelector(".bs-intro-toggle");
      if (!copy || !toggle) return;
      intro.classList.add("is-ready");

      function measure() {
        if (intro.classList.contains("is-expanded")) return;
        toggle.hidden = !(copy.scrollWidth > copy.clientWidth + 1 || copy.scrollHeight > copy.clientHeight + 1);
      }

      toggle.addEventListener("click", function () {
        var open = intro.classList.toggle("is-expanded");
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        toggle.setAttribute("aria-label", toggle.getAttribute(open ? "data-label-less" : "data-label-more") || "");
        // Open, the copy is a scrolling box; rewind it on close or the one
        // line left showing is wherever the reader stopped.
        if (!open) copy.scrollTop = 0;
      });

      measure();
      var queued = false;
      window.addEventListener("resize", function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; measure(); });
      }, { passive: true });
      // Web fonts landing late change the line's width.
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    });
  }


  /* ── Boot ───────────────────────────────────────────────── */
  /* Special Prices countdown (snippets/sale-countdown.liquid). One shared 1s ticker
     updates every [data-sale-countdown] on the page, re-querying each tick so
     timers the theme editor re-renders keep counting. Dates are the store's
     Qatar time (UTC+3, no daylight saving). The phase follows the dates:
     before start -> "Starts in"; running -> "Ends in"; past end -> hidden;
     started with no end -> "Live now". Unreadable dates leave it hidden. */
  var saleCountdownTicker = null;

  function parseSaleDate(str) {
    var m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?\s*$/.exec(str || "");
    if (!m) return NaN;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], (+m[4] || 0) - 3, +m[5] || 0);
  }

  // Restart a CSS animation class from its first frame.
  function restartClass(el, cls) {
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  }

 
function tickSaleCountdowns() {
  var now = Date.now();
  var pad = function (n) {
    return n < 10 ? "0" + n : String(n);
  };

  var shine = Math.floor(now / 1000) % 5 === 0;

  document.querySelectorAll("[data-sale-countdown]").forEach(function (el) {
    var start = parseSaleDate(el.getAttribute("data-start"));
    var end = parseSaleDate(el.getAttribute("data-end"));

    // Hide if explicitly disabled, end date is missing,
    // or the promotion has expired.
    if (
      el.getAttribute("data-countdown-enabled") === "false" ||
      isNaN(end) ||
      now >= end
    ) {
      el.hidden = true;
      return;
    }

    var target, phase;

    if (!isNaN(start) && now < start) {
      target = start;
      phase = "starts";
    } else {
      target = end;
      phase = "ends";
    }

    el.classList.remove("is-live");
    el.classList.toggle("is-running", phase === "ends");

    var label = el.querySelector("[data-sale-countdown-label]");
    if (label) {
      label.textContent = el.getAttribute(
        phase === "ends" ? "data-label-ends" : "data-label-starts"
      ) || "";
    }

    var s = Math.max(0, Math.ceil((target - now) / 1000));

    var parts = {
      d: Math.floor(s / 86400),
      h: Math.floor((s % 86400) / 3600),
      m: Math.floor((s % 3600) / 60),
      s: s % 60
    };

    Object.keys(parts).forEach(function (k) {
      var num = el.querySelector('[data-unit="' + k + '"]');
      var next = pad(parts[k]);

      if (!num) return;

      num.classList.toggle("is-tick", num.textContent !== next);
      num.textContent = next;
    });

    var dayWrap = el.querySelector('[data-unit-wrap="d"]');
    if (dayWrap) {
      dayWrap.hidden = parts.d === 0;
    }

    el.hidden = false;

    restartClass(el, "is-beat");
    if (shine) restartClass(el, "is-shine");
  });
}


  function initSaleCountdown() {
    tickSaleCountdowns();
    if (saleCountdownTicker || !document.querySelector("[data-sale-countdown]")) return;
    // Start the 1s ticker on the wall clock's second boundary, so the seconds
    // tile turns over exactly when the second does.
    saleCountdownTicker = setTimeout(function () {
      tickSaleCountdowns();
      saleCountdownTicker = setInterval(tickSaleCountdowns, 1000);
    }, 1000 - (Date.now() % 1000));
  }

  function initAll() {
    initAnnouncements();
    initStickyNav();
    initMobileStickyBar();
    initMobileSearchTrigger();
    initSearchClear();
    initMegaMenu();
    initLanguageSwitcher();
    initHeaderIntros();
    // The theme editor re-renders a section's markup on every setting change.
    document.addEventListener("shopify:section:load", function (e) { initHeaderIntros(e.target); });
    initAccountDropdown();
    initPhoneCodeCombobox();
    initCountryFlagSelects();
    // Before initRegisterPhoneTag: its submit handler must run first so a
    // rejected number never reaches the tag-stashing step.
    initRegisterPhoneField();
    initAccountEmailFields();
    initRegisterNameFields();
    initRegisterPhoneTag();
    initLoginReturnTo();
    initPostLoginRedirect();
    initPasswordToggles();
    // After the toggles: the error/hint slots go outside .bs-password-field,
    // which initPasswordToggles is the one that builds.
    initNewPasswordFields();
    initSignInPasswordFields();
    initMobileDrawer();
    initSaleCountdown();
    initStoreDrawer();
    initCartDrawer();
    hydrateWishlistCount();
    document.querySelectorAll("[data-hero]").forEach(initHero);
    document.querySelectorAll("[data-bs-slider-wrapper]").forEach(initSlider);
    document.querySelectorAll(".product-grid-slider-wrap").forEach(alignProductSliderArrows);
    document.querySelectorAll("[data-brands-marquee]").forEach(initMarquee);
    document.querySelectorAll("[data-bs-drag-scroll]").forEach(initDragScroll);
    document.querySelectorAll("[data-brands-directory]").forEach(initBrandsDirectory);
    document.querySelectorAll("[data-track-order]").forEach(initTrackOrder);
    /* In-page maps (contact page). The header drawer's map stays deferred to
       openDrawer because it's hidden until then; these are part of the page,
       so there's nothing to defer them behind. */
    document.querySelectorAll("[data-store-map-inline]").forEach(initStoreMap);
    initFittingAppointmentDate();
    initOtherBrandsPanel();
  }

  /* ---------- footer "Other Brands" panel ----------
     Nineteen sister sites in one column is taller than the footer strip, and
     .bs-mainfooter is overflow:hidden, so the panel is position:fixed (see
     .bs-otherbrands-menu in blue-salon.css) and placed here against the
     viewport instead of against the strip.

     Measured on open, and again on resize and scroll while it is open: the
     panel goes on whichever side of the toggle has more room, is capped to
     that room so it can never run off-screen, and is clamped horizontally so
     a toggle near an edge does not push it out of view. It only scrolls when
     even the taller side cannot fit the list. */
  function initOtherBrandsPanel() {
    var wrap = document.querySelector(".bs-otherbrands");
    if (!wrap || wrap.dataset.obInit === "1") return;
    var menu = wrap.querySelector(".bs-otherbrands-menu");
    var toggle = wrap.querySelector(".bs-otherbrands-toggle");
    if (!menu || !toggle) return;
    wrap.dataset.obInit = "1";

    var GAP = 8;
    var EDGE = 12;

    var MAX_COLS = 4;
    var VIEWPORT_SHARE = 0.55; // a dropdown, not a takeover

    function place() {
      if (!wrap.open) return;
      // Cleared first so natural size can be measured; a cap left in place
      // makes the panel report its capped height and never grow back when
      // the viewport gets taller again.
      menu.style.setProperty("--bs-ob-maxh", "none");

      var t = toggle.getBoundingClientRect();
      var vh = document.documentElement.clientHeight;
      var vw = document.documentElement.clientWidth;
      var above = t.top - GAP - EDGE;
      var below = vh - t.bottom - GAP - EDGE;

      // Prefer opening upward - this is the last strip on the page, so there
      // is nearly always more room above - but take the roomier side when it
      // does not fit.
      var up = above >= below;
      var room = Math.min(up ? above : below, Math.round(vh * VIEWPORT_SHARE));
      var availW = vw - EDGE * 2;

      /* Spread across whatever width there is instead of down. One column of
         nineteen links measured 567px tall - 63% of a 1440x900 viewport, 85%
         of a 360x640 one - while leaving most of the screen's width unused,
         and it scrolled on short viewports. Choosing the row count from the
         room available turns that spare width into columns, which is what
         keeps the panel short enough not to need a scrollbar at all. */
      var items = menu.querySelectorAll("li").length || 1;
      var pad = menu.offsetHeight - menu.clientHeight + 16;
      var first = menu.querySelector("li");
      var itemH = first ? first.offsetHeight : 29;
      var rowsThatFit = Math.max(1, Math.floor((room - pad) / itemH));
      var cols = Math.min(MAX_COLS, Math.max(1, Math.ceil(items / rowsThatFit)));
      var rows = Math.ceil(items / cols);
      menu.style.setProperty("--bs-ob-rows", rows);

      // Columns are max-content, so the only way to know the resulting width
      // is to measure it. Drop a column while it is too wide - at most a few
      // passes, and it always terminates at one column.
      while (cols > 1 && menu.offsetWidth > availW) {
        cols -= 1;
        rows = Math.ceil(items / cols);
        menu.style.setProperty("--bs-ob-rows", rows);
      }

      var needed = menu.offsetHeight;
      if (needed > room) menu.style.setProperty("--bs-ob-maxh", room + "px");

      var h = Math.min(needed, room);
      var top = up ? t.top - GAP - h : t.bottom + GAP;
      menu.style.setProperty("--bs-ob-top", Math.round(top) + "px");

      // Align to the toggle's reading-start edge, then clamp both sides so a
      // toggle near an edge cannot push the panel off-screen.
      var w = menu.offsetWidth;
      var left = document.documentElement.dir === "rtl" ? t.right - w : t.left;
      left = Math.max(EDGE, Math.min(left, vw - w - EDGE));
      menu.style.setProperty("--bs-ob-left", Math.round(left) + "px");
    }

    wrap.addEventListener("toggle", function () {
      if (wrap.open) place();
    });
    window.addEventListener("resize", place);
    // capture: the strip can sit inside its own scrolling ancestor, whose
    // scroll events do not bubble to window.
    window.addEventListener("scroll", place, true);

    // A fixed panel does not move with the page, so leaving it open after a
    // click elsewhere reads as a stuck overlay.
    document.addEventListener("click", function (e) {
      if (wrap.open && !wrap.contains(e.target)) wrap.open = false;
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && wrap.open) {
        wrap.open = false;
        toggle.focus();
      }
    });
  }


  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Re-init sections re-rendered by the theme editor.
  document.addEventListener("shopify:section:load", initAll);
})();
